// 2024-10-07T09:50:13.218Z  (1728294613218)
export const locale = {
	lang: 'de',
	data: {
		'ACCOUNTING_VALUE': 'Zusatzwert',
		'ACCOUNTING_VALUES': 'Zusatzwerte',
		'ACCOUNTING_VALUE.COMPUTE_IN_STATES': 'Berechnung nur in ausgewähltem Arbeitszustand',
		'ACCOUNTING_VALUE.VALUE_AGGREGATION': 'Werteaggregation',
		'ACCOUNTING_VALUE.VALUE_COMPUTATION': 'Werteberechnung',
		'ACCOUNTING_VALUE.VALUE_SUMMATION': 'Wertesummierung',
		"ACCOUNTING_VALUE.RESOURCE_TYPE": "Betriebsmitteltyp",
		'ACCOUNT_ACTIVATION': 'Kontoaktivierung',
		'ACCOUNT_ACTIVATION.CODE': 'Aktivierungscode',
		'ACCOUNT_ACTIVATION.CODE.RESEND': 'Code erneut senden',
		'ACCOUNT_ACTIVATION.INTRO': 'Bitte geben Sie den Aktivierungscode ein, den Sie per Email erhalten haben',
		'ACID': 'Säure',
		'ACTIVATE': 'Aktivieren',
		'ACTIVATE.SELECTED': 'Ausgewählte aktivieren',
		'ACTIVE': 'Aktiv',
		'ACTIVITIES.DAILY': 'Tagesaktivitäten',
		'ACTIVITIES.EXPORT': 'Export von Aktivitäten',
		'ACTIVITIES.NO': 'Keine Aktivitäten',
		'ACTIVITIES.WEEKLY': 'Wochenaktivitäten',
		'ACTIVITY': 'Aktivität',
		'ACTIVITY.EXPORT_DETAILS': 'Export der Aktivität',
		'ACTIVITY.NO_FIELDS_WORKED': 'Es wurde auf keinen eingetragenen Feldern gearbeitet',
		'ADAPTER': 'Adapter',
		'ADAPTER.ASSIGN': 'Adapter zuweisen',
		'ADAPTER.ASSIGN.FAILURE': 'Es gab einen Fehler beim Verbinden des Adapters',
		'ADAPTER.ASSIGN.SUCCESS': 'Adapter erfolgreich zugewiesen',
		'ADAPTER.ASSIGNED_MACHINE': 'Zugewiesene Maschine',
		'ADAPTER.ASSIGNMENT': 'Zuweisen von Adapter',
		'ADAPTER.CHOSEN': 'Gewählter Adapter',
		'ADAPTER.LOAD.FAILURE': 'Es gab einen Fehler beim Laden der Adapter',
		'ADAPTER.NO': 'Kein Adapter',
		'ADAPTER.NONE_AVAILABLE': 'Kein Adapter verfügbar',
		'ADAPTER.PAIR_INFO': 'Wähle den entsprechenden Adapter aus. Bereits zugewiesene Adapter werden mit der neuen Maschine überschrieben. Die neue Adapterkonfiguration wird automatisch beim nächsten Neustart des Adapters geladen.',
		'ADAPTER.PREVIOUS': 'Vorheriger Adapter',
		'ADAPTERS.NO': 'Keine Adapter',
		'ADBLUE.LEVEL': 'AdBlue Füllstand',
		'ADD': 'Hinzufügen',
		'ADDITIONAL_VALUE': 'Sensorwert',
		'ADDITIVE': 'Additiv',
		'ADDRESS': 'Adresse',
		'ALL': 'Alle',
		'ALL_DEVICES': 'Alle Adapter',
		'AMOUNT': 'Menge',
		'AMOUNT.INVALID': 'Menge ungültig',
		'AMOUNTS': 'Menge',
		'APPLY': 'Anwenden',
		'ARCHIVE': 'Archivieren',
		'ARCHIVE.SELECTED': 'Ausgewählte archivieren',
		'AREA': 'Fläche',
		'AREA.FIELD': 'Fläche Felder',
		'AREA.LOCATION': 'Fläche Orte',
		'AREA.PERFORMANCE': 'Flächenleistung',
		'AREA.PROCESSED': 'Bearbeitete Fläche',
		'AREA.TOTAL': 'Gesamtfläche',
		'AREA.WORKED': 'Gearbeitete Fläche',
		'ASSIGN': 'Zuweisen',
		'AUTH.REMEMBER_ME': 'Angemeldet bleiben',
		'BACK': 'Zurück',
		'BALES': 'Ballen',
		'BASIC_DATA': 'Basisdaten ',
		'BEACON': 'Beacon',
		'BEACON.ASSIGN': 'Beacon zuweisen',
		'BEACON.ASSIGN.SUCCESS': 'Beacon erfolgreich zugewiesen',
		'BEACON.ASSIGNED_EMPLOYEE': 'Zugewiesener Mitarbeiter',
		'BEACON.ASSIGNED_IMPLEMENT': 'Zugewiesenes Anbaugerät',
		'BEACON.ASSIGN_TO_EMPLOYEE': 'Zuweisen von Beacon zu Mitarbeiter',
		'BEACON.ASSIGN_TO_IMPLEMENT': 'Zuweisen von Beacon zu Anbaugerät',
		'BEACON.CHOSEN': 'Gewählter Beacon',
		'BEACON.ERROR': 'Es gab einen Fehler beim Zuweisen des Beacon',
		'BEACON.LOAD_ERROR': 'Es gab einen Fehler beim Laden der Beacons',
		'BEACON.NONE_AVAILABLE': 'Keine Beacon verfügbar',
		'BEACON.NO_BEACON': 'Kein Beacon',
		'BEACON.PAIR_INFO_EMPLOYEE': 'Wähle den entsprechenden Beacon aus. Bereits zugewiesene Beacon werden mit dem neuen Mitarbeiter überschrieben.',
		'BEACON.PAIR_INFO_IMPLEMENT': 'Wähle das entsprechende Beacon aus. Bereits zugewiesene Beacons werden mit dem neuen Anbaugerät überschrieben.',
		'BEACON.PREVIOUS': 'Vorheriger Beacon',
		'BEACONS': 'Beacons',
		'BUILD_YEAR': 'Baujahr',
		'BUILD_YEAR.INVALID': 'Baujahr ungültig',
		'CAN.STATUS': 'CAN Status',
		'CANCEL': 'Abbrechen',
		'CHANGE': 'Ändern',
		'CHANGE.NO': 'Keine Änderung',
		'CHOOSE_ALL': 'Alle auswählen',
		'CHOOSE_ROLE': 'Rolle auswählen',
		'CHRONOLOGICAL': 'Chronologischer Verlauf',
		'CLICK_PROCESS': 'Prozess auswählen um weitere Details zu erhalten',
		'CLOSE': 'Schliessen',
		'CO2.EMISSION': 'CO2 Ausstoß',
		'CO2.PER': 'CO2 pro Hektar',
		'CO2.TOTAL': 'Gesamtmenge CO2',
		'COLOR': 'Farbe',
		'COMMENT': 'Kommentar',
		'CONDITION': 'Bedingung',
		'CONFIRM': 'Bestätigen',
		'CONFIRM_PASSWORD': 'Passwort bestätigen',
		'CONNECT': 'Verbinden',
		'CONTACT_PERSON': 'Kontaktperson',
		'CONTINUE': 'Weiter',
		'COST': 'Kosten',
		'COST.INVALID': 'Kostensatz ungültig',
		'COST.OVERALL': 'Gesamtkosten',
		'COST.OVERALL.ARRIVAL': 'Gesamtkosten Anfahrt',
		'COST.OVERALL.DRIVER': 'Gesamtkosten Fahrer',
		'COST.OVERALL.FIELD_TIME': 'Gesamtkosten Feldzeit',
		'COST.OVERALL.IMPLEMENTS': 'Gesamtkosten Anbaugeräte',
		'COST.OVERALL.MACHINES': 'Gesamtkosten Fahrzeuge',
		'COST.OVERALL.PREPARATION': 'Gesamtkosten Vorbereitung',
		'COST.TOTAL': 'Gesamtkosten',
		'COSTS': 'Kosten',
		'COST_RATE': 'Kostensatz',
		'COUNTRY': 'Land',
		'COVERAGE': 'Bedeckung',
		'COVERAGE.MAP': 'Bedeckungskarte',
		'COVERAGE.MAP.SETTINGS': 'Einstellungen Bedeckungskarte',
		'COVERAGE.MAP.ZONES': 'Zonen',
		'CREATED': 'Erstellt',
		'CREATE_USER': 'Benutzer anlegen',
		"CROP": "Saatgut",
		'CROP.TYPE': 'Kultur',
		'CROP.NO_CROP': 'Keine Kultur',
		'CURRENCY': 'Währung',
		'CUSTOMER': 'Kunde',
		'CUSTOMER.ADD': 'Neuen Kunden hinzufügen',
		'CUSTOMER.ADD.SUCCESS': 'Kunde erfolgreich hinzugefügt',
		'CUSTOMER.ASSIGN': 'Kunden zuweisen',
		'CUSTOMER.DELETE.QUESTION': 'Wollen sie den Kunden wirklich löschen?',
		'CUSTOMER.DELETE.SUCCESS': 'Kunde gelöscht',
		'CUSTOMER.DETAILS': 'Details Kunde',
		'CUSTOMER.EDIT': 'Kunde bearbeiten',
		'CUSTOMER.EDIT.SUCCESS': 'Kunde erfolgreich bearbeitet',
		'CUSTOMER.NAME': 'Kundenname',
		'CUSTOMER.NO': 'Kein Kunde',
		'CUSTOMER.NOT_SELECTED': 'Kein Kunde ausgewählt',
    'CUSTOMER.NO.ASSIGNEE': 'Keinem Kunden zugeordnet',
		'CUSTOMER.SELECT': 'Kunden auswählen',
		'CUSTOMERS': 'Kunden',
		'CUSTOMERS.ALL': 'Alle Kunden',
		'CUSTOMERS.DELETE.FAILURE': 'Nicht alle ausgewählten Kunden konnten gelöscht werden!',
		'CUSTOMERS.DELETE.QUESTION': 'Sollen die ausgewählten Kunden wirklich gelöscht werden?',
		'CUSTOMERS.DELETE.SUCCESS': 'Die ausgewählten Kunden wurden gelöscht',
		'CUSTOMERS.MANAGEMENT': 'Kundenverwaltung',
		'CUSTOMERS.NO': 'Keine Kunden',
		'CUSTOMERS.SELECTED': 'Ausgewählte Kunden',
		'CUSTOM_LABELING': 'Individuelle Zustandsbestimmung',
		'CUSTOM_LABELING.ADD_WORKSTATE': 'Neuen Arbeitszustand hinzufügen',
		'CUSTOM_LABELING.DEFINE_FOR_IMPLEMENT': 'Definiere eigene Arbeitszustände explizit für dieses Anbaugerät',
		'CUSTOM_LABELING.DEFINE_INDIVIDUAL_CONDITION': 'Eigene Arbeitszustände für Gerät definieren',
		'CUSTOM_LABELING.EDIT.SUCCESS': 'Arbeitszustände erfolgreich erstellt',
		'CUSTOM_LABELING.INDIVIDUAL_CONDITION': 'Individueller Arbeitszustand  ',
		'CUSTOM_LABELING.ISOBUS_OVERRIDE': 'Überschreiben durch ISOBUS Arbeitszustände erlauben',
		'CUSTOM_LABELING.NO_LABELS_AVAILABLE': 'Kein Arbeitszustand verfügbar',
		'DASHBOARD.GPS_DATA.NO': 'Keine GPS Daten',
		'DASHBOARD.MACHINE_POSITIONS.LOAD.FAILURE': 'Es gab einen Fehler beim Laden der Maschinenpositionen',
		'DATA': 'Daten',
		'DATA.ARCHIVED.WARNING': 'Zugrundeliegende Daten sind teilweise oder gänzlich archiviert',
		'DATA.EXPORT': 'Datenexport',
		'DATA.INPUT': 'Dateneingabe',
		'DATA.UPDATING.WARNING': 'Zugrundeliegende Daten werden geupdated',
		'DATA_PREPARATION': 'Datenaufbereitung',
		'DATE': 'Datum',
		'DATE.APRIL': 'April',
		'DATE.AUGUST': 'August',
		'DATE.DECEMBER': 'Dezember',
		'DATE.FEBRUARY': 'Februar',
		'DATE.FRIDAY': 'Freitag',
		'DATE.FROM': 'Von',
		'DATE.JANUARY': 'Januar',
		'DATE.JULY': 'Juli',
		'DATE.JUNE': 'Juni',
		'DATE.MARCH': 'März',
		'DATE.MAY': 'Mai',
		'DATE.MONDAY': 'Montag',
		'DATE.NOVEMBER': 'November',
		'DATE.OCTOBER': 'Oktober',
		'DATE.PERIOD': 'Zeitraum',
		'DATE.RANGE': 'Von / bis',
		'DATE.SATURDAY': 'Samstag',
		'DATE.SEPTEMBER': 'September',
		'DATE.SUNDAY': 'Sonntag',
		'DATE.THURSDAY': 'Donnerstag',
		'DATE.TUESDAY': 'Dienstag',
		'DATE.UNTIL': 'Bis',
		'DATE.WEDNESDAY': 'Mittwoch',
		'DAY.CURRENT': 'Aktueller Tag',
		'DAY.NEXT': 'Nächster Tag',
		'DAY.PREVIOUS': 'Vorheriger Tag',
		'DAY.SELECTED': 'Gewählter Tag',
		'DAYS': 'Tage',
		'DAY_ACTIVITIES': 'Tagesaktivitäten',
		'DEACTIVATE': 'Deaktivieren',
		'DEACTIVATE.SELECTED': 'Ausgewählte deaktivieren',
		'DEADLINE': 'Frist',
		'DEADLINE.ADD': 'Frist hinzufügen',
		'DEADLINE.ADD.SUCCESS': 'Frist erfolgreich hinzugefügt',
		'DEADLINE.DELETE.SUCCESS': 'Frist gelöscht',
		'DEADLINE.DONE': 'Erledigt',
		'DEADLINE.DUE': 'Abgelaufene Frist',
		'DEADLINE.DUE_IN_AT': 'Fällig bei / am',
		'DEADLINE.EDIT': 'Frist bearbeiten',
		'DEADLINE.EDIT.SUCCESS': 'Frist erfolgreich bearbeitet',
		'DEADLINE.IS_CLOSE': 'Diese Frist läuft bald ab',
		'DEADLINE.IS_OVERDUE': 'Diese Frist ist überfällig',
		'DEADLINE.OPEN': 'Offen',
		'DEADLINE.PROCESS.SUCCESS': 'Frist erfolgreich abgearbeitet',
		'DEADLINE.PROCESSED': 'Bearbeitet',
		'DEADLINE.PROCESSED.SUCCESS': 'Frist erfolgreich bearbeitet',
		'DEADLINE.WARN': 'Anstehende Frist',
		'DEADLINES': 'Fristen',
		'DEADLINES.NO': 'Keine Fristen',
		'DEFINE_ROLE': 'Rolle definieren',
		'DELETE': 'Löschen',
		'DELETE.SELECTED': 'Ausgewählte löschen',
		'DELETED': 'Gelöscht',
		'DESCRIPTION': 'Beschreibung',
		'DIAGRAM': 'Diagramm',
		'DISPLAY': 'Anzeigen',
		'DISPLAY_TRACK': 'Fahrspur anzeigen',
		'DISTANCE': 'Strecke',
		'DISTANCE.TOTAL': 'Gesamtstrecke',
		'DISTANCE.WORKED': 'Bearbeitete Strecke',
		'DOWNLOAD': 'Herunterladen',
		'DRIVER': 'Fahrer',
		'DRIVER.EDIT': 'Fahrer bearbeiten',
		'DRIVER.FIXED': 'Fester Fahrer',
		'DRIVER.NO': 'Kein Fahrer',
		'DRIVER.REMOVE': 'Fahrer entfernen',
		'DRIVERS': 'Fahrer',
		'DRIVERS.ALL': 'Alle Fahrer',
		'DRIVER_SCAN_DISABLED': 'Fahrer-Beacon Scan deaktivieren',
		'DURATION': 'Dauer',
		'DURATION.WORKED': 'Gearbeitete Zeit',
		'EDIT': 'Bearbeiten',
		'EDIT.SELECTED': 'Ausgewählte bearbeiten',
		'EDIT_USER': 'Benutzer bearbeiten',
		'EMAIL': 'Kontakt E-Mail',
		'EMAIL.ACTIVATE': 'E-Mail Adresse aktivieren',
		'EMAIL.ACTIVATE.CODE': 'Freischaltcode',
		'EMAIL.ACTIVATE.EXPLANATION': 'Wenn Sie ihre E-Mail Adresse geändert haben, erhalten Sie auf ihrer neuen E-Mail Adresse einen Freischaltcode.',
		'EMAIL.CHANGE': 'E-Mail Adresse ändern',
		'EMAIL.CHANGE.SUCCESS': 'Ihre E-Mail Adresse wurde erfolgreich geändert',
		'EMAIL.CONFIRM': 'Email bestätigen',
		'EMAIL.CURRENT': 'Aktuelle E-Mail Adresse',
		'EMAIL.INVALID': 'E-Mail ungültig',
		'EMAIL.NEW': 'Neue E-Mail Adresse',
		'EMAIL.NO_MATCH': 'E-Mail Adressen stimmen nicht überein',
		'EMPLOYEE': 'Mitarbeiter',
		'EMPLOYEE.ACTIVATE.QUESTION': 'Wollen Sie die ausgewählten Mitarbeiter aktiv setzen?',
		'EMPLOYEE.ADD': 'Mitarbeiter anlegen',
		'EMPLOYEE.ADD.SUCCESS': 'Mitarbeiter erfolgreich hinzugefügt',
		'EMPLOYEE.CREATE': 'Mitarbeiter anlegen',
		'EMPLOYEE.CREATE.SUCCESS': 'Mitarbeiter angelegt',
		'EMPLOYEE.DEACTIVATE.QUESTION': 'Wollen sie den Mitarbeiter wirklich deaktivieren?',
		'EMPLOYEE.DELETE.QUESTION': 'Wollen sie den Mitarbeiter wirklich löschen?',
		'EMPLOYEE.EDIT': 'Mitarbeiter bearbeiten',
		'EMPLOYEE.EDIT.SUCCESS': 'Mitarbeiter erfolgreich bearbeitet',
		'EMPLOYEE.ROLE': 'Rolle des Mitarbeiters',
		'EMPLOYEE.ROLE_OF': 'Rolle des Mitarbeiters',
		'EMPLOYEES': 'Mitarbeiter',
		'EMPLOYEES.ACTIVATE.QUESTION': 'Wollen Sie die Mitarbeiter aktiv setzen?',
		'EMPLOYEES.ACTIVATE.SUCCESS': 'Die Mitarbeiter wurden aktiviert',
		'EMPLOYEES.ALL': 'Alle Mitarbeiter',
		'EMPLOYEES.DEACTIVATE.FAILURE': 'Nicht alle ausgewählten Mitarbeiter konnten inaktiv gesetzt werden',
		'EMPLOYEES.DEACTIVATE.QUESTION': 'Wollen Sie die Mitarbeiter inaktiv setzen?',
		'EMPLOYEES.DEACTIVATE.SUCCESS': 'Die Mitarbeiter wurden inaktiv gesetzt',
		'EMPLOYEES.DELETE.FAILURE': 'Nicht alle ausgewählten Mitarbeiter konnten gelöscht werden',
		'EMPLOYEES.DELETE.QUESTION': 'Wollen Sie die ausgewählten Mitarbeiter löschen?',
		'EMPLOYEES.DELETE.SUCCESS': 'Die Mitarbeiter wurden gelöscht',
		'EMPLOYEES.MANAGEMENT': 'Mitarbeiterverwaltung',
		'EMPLOYEES.NO': 'Keine Mitarbeiter',
		'EMPLOYEES.NOT_SELECTED': 'Keine Mitarbeiter ausgewählt',
		'EMPLOYEES.SELECTED': 'Ausgewählte Mitarbeiter',
		'EMPLOYER.NO': 'Kein Arbeitgeber',
		'EMPLOYER.NOT_SELECTED': 'Kein Arbeitgeber ausgewählt',
		'EMPLOYES.NO': 'Keine Mitarbeiter',
		'END_DRAW_MODE': 'Zeichenmodus beendet',
		'ENTERPRISE': 'Betrieb',
		'ENTERPRISE.ADD': 'Betrieb hinzufügen',
		'ENTERPRISE.ADD.EMPLOYER_REQUIRED': 'Du musst einen Betrieb hinzufügen',
		'ENTERPRISE.ADD.SUCCESS': 'Unternehmen erfolgreich hinzugefügt',
		'ENTERPRISE.ADDED.SUCCESS': 'Betrieb erfolgreich hinzugefügt.',
		'ENTERPRISE.ENTER_ACCESS_TOKEN': 'Bitte geben Sie den Zugangscode für den hinzuzufügenden Betrieb ein',
		'ENTERPRISE.NAME': 'Betriebsname',
		'ENTERPRISE.NOT_SELECTED': 'Kein Betrieb ausgewählt',
		'ENTERPRISE.OF': 'Betrieb von:',
		'ENTERPRISE.SETTINGS': 'Einstellungen',
		'ENTERPRISE.SETTINGS.CONFIGURATION_UPDATE.SUCCESS': 'Betriebseinstellungen erfolgreich bearbeitet',
		'ENTERPRISE.SETTINGS.MACHINES_SYNC.SUCCESS': 'Maschinen erfolgreich synchronisiert',
		'ENTERPRISE_LICENSE.EMPLOYEES': 'Mitarbeiter-Lizenzen',
		'ENTERPRISE_LICENSE.LICENSE': 'Lizenz',
		'ENTERPRISE_LICENSE.MACHINE': 'Maschinenlizenz',
		'ENTERPRISE_LICENSE.MACHINES': 'Maschinenlizenzen',
		'ENTERPRISE_MIN': 'Betriebsname muss mindestens 3 Zeichen lang sein',
		'ENTERPRISE_NAME_REQUIRED': 'Betriebsname erforderlich',
		'ENTERPRISE_SELECTION.ADD_ENTERPRISE': 'Betrieb hinzufügen',
		'ENTERPRISE_SELECTION.LICENSE_EXPIRED': 'Lizenz abgelaufen',
		'ENTERPRISE_SELECTION.REQUEST_TEST_ACCOUNT': 'Test-Konto anfragen',
		'ENTERPRISE_STATISTICS': 'Betriebsstatistiken',
		'ENTERPRISE_STATISTICS.COST_DIAGRAMM': 'Kostendiagramm',
		'ENTERPRISE_STATISTICS.PROCESS_DIVISION': 'Prozessaufteilung',
		'ENUM.ACCOUNTING_COMP_MODE.A': 'Alle',
		'ENUM.ACCOUNTING_COMP_MODE.WT': 'Nur in Arbeitsstellung',
		'ENUM.ACCOUNTING_MODE.AVG': 'Durchschnitt',
		'ENUM.ACCOUNTING_MODE.MAX': 'Maximum',
		'ENUM.ACCOUNTING_MODE.MED': 'Median',
		'ENUM.ACCOUNTING_MODE.MIN': 'Minimum',
		'ENUM.ACCOUNTING_MODE.SUM': 'Summe',
		'ENUM.ACCOUNTING_VALUE_MODE.ABSDIF': 'Absolute Differenz',
		'ENUM.ACCOUNTING_VALUE_MODE.DIR': 'Direkt',
		'ENUM.ACCOUNTING_VALUE_MODE.NEGDIF': 'Negative Differenz',
		'ENUM.ACCOUNTING_VALUE_MODE.POSDIF': 'Positive Differenz',
		'ENUM.ACCOUNTING_VALUE_MODE.TIMACT': 'Zeit aktiv',
		'ENUM.BEACONTYPE.BDrv': 'Fahrer Beacon',
		'ENUM.BEACONTYPE.BImpl': 'Anbaugeräte Beacon',
		'ENUM.CAN_IDENTIFIER.A1': 'IO-Box: Analog 1',
		'ENUM.CAN_IDENTIFIER.A2': 'IO-Box: Analog 2',
		'ENUM.CAN_IDENTIFIER.A3': 'IO-Box: Analog 3',
		'ENUM.CAN_IDENTIFIER.A4': 'IO-Box: Analog 4',
		'ENUM.CAN_IDENTIFIER.AUX0_Ext_Fl': 'Load sensing \"+\"',
		'ENUM.CAN_IDENTIFIER.AUX0_Ret_Fl': 'Load sensing \"-\"',
		'ENUM.CAN_IDENTIFIER.AUX1_Ext_Fl': 'I. Steuergerät \"+\"',
		'ENUM.CAN_IDENTIFIER.AUX1_Ret_Fl': 'I. Steuergerät \"-\"',
		'ENUM.CAN_IDENTIFIER.AUX2_Ext_Fl': 'II. Steuergerät \"+\"',
		'ENUM.CAN_IDENTIFIER.AUX2_Ret_Fl': 'II. Steuergerät \"-\"',
		'ENUM.CAN_IDENTIFIER.AUX3_Ext_Fl': 'III. Steuergerät \"+\"',
		'ENUM.CAN_IDENTIFIER.AUX3_Ret_Fl': 'III Steuergerät \"-\"',
		'ENUM.CAN_IDENTIFIER.AUX4_Ext_Fl': 'IV. Steuergerät \"+\"',
		'ENUM.CAN_IDENTIFIER.AUX4_Ret_Fl': 'IV. Steuergerät \"-\"',
		'ENUM.CAN_IDENTIFIER.Ag1avg': 'IO-Box: Winkel 1 Durchschnitt',
		'ENUM.CAN_IDENTIFIER.Ag1max': 'IO-Box: Winkel 1 Max.',
		'ENUM.CAN_IDENTIFIER.Ag1min': 'IO-Box: Winkel 1 Min.',
		'ENUM.CAN_IDENTIFIER.Ag2avg': 'IO-Box: Winkel 2 Durchschnitt',
		'ENUM.CAN_IDENTIFIER.Ag2max': 'IO-Box: Winkel 2 Max.',
		'ENUM.CAN_IDENTIFIER.Ag2min': 'IO-Box: Winkel 2 Min.',
		'ENUM.CAN_IDENTIFIER.Ag3avg': 'IO-Box: Winkel 3 Durchschnitt',
		'ENUM.CAN_IDENTIFIER.Ag3max': 'IO-Box: Winkel 3 Max.',
		'ENUM.CAN_IDENTIFIER.Ag3min': 'IO-Box: Winkel 3 Min.',
		'ENUM.CAN_IDENTIFIER.ApplAci': 'SyreN: Ausgebrachte Säure',
		'ENUM.CAN_IDENTIFIER.ApplAdd': 'SyreN: Ausgebrachte Additive',
		'ENUM.CAN_IDENTIFIER.ApplSlu': 'SyreN: Ausgebrachte Gülle',
		'ENUM.CAN_IDENTIFIER.AxleWeight_1': 'Achsgewicht 1',
		'ENUM.CAN_IDENTIFIER.AxleWeight_2': 'Achsgewicht 2',
		'ENUM.CAN_IDENTIFIER.C1': 'IO-Box: Zähler 1',
		'ENUM.CAN_IDENTIFIER.C2': 'IO-Box: Zähler 2',
		'ENUM.CAN_IDENTIFIER.Chop_Act': 'Status Häckseltrommel',
		'ENUM.CAN_IDENTIFIER.Circ_1_Stat': 'Unimog: Status Steuergerät 1',
		'ENUM.CAN_IDENTIFIER.Circ_2A_Stat': 'Unimog: Status Steuergerät 2A',
		'ENUM.CAN_IDENTIFIER.Circ_2B_Stat': 'Unimog: Status Steuergerät 2B',
		'ENUM.CAN_IDENTIFIER.Circ_3_Stat': 'Unimog: Status Steuergerät 3',
		'ENUM.CAN_IDENTIFIER.Circ_4_Stat': 'Unimog: Status Steuergerät 4',
		'ENUM.CAN_IDENTIFIER.ClutSlip': 'Unimog: Schlupf Kupplung',
		'ENUM.CAN_IDENTIFIER.Cutter_Guide': 'Schneidwerksführung',
		'ENUM.CAN_IDENTIFIER.Cutter_GuideP': 'SchneidwerksführungP',
		'ENUM.CAN_IDENTIFIER.Cutter_Pos': 'Schneidwerksposition',
		'ENUM.CAN_IDENTIFIER.Cutter_State': 'Status Schneidwerk',
		'ENUM.CAN_IDENTIFIER.D1': 'IO-Box: Digital 1',
		'ENUM.CAN_IDENTIFIER.D2': 'IO-Box: Digital 2',
		'ENUM.CAN_IDENTIFIER.D3': 'IO-Box: Digital 3',
		'ENUM.CAN_IDENTIFIER.D4': 'IO-Box: Digital 4',
		'ENUM.CAN_IDENTIFIER.Driv_Lever': 'Fahrwahlhebel',
		'ENUM.CAN_IDENTIFIER.ENG_ABLev': 'AdBlue Füllstand',
		'ENUM.CAN_IDENTIFIER.ENG_FueLev': 'Tankfüllstand',
		'ENUM.CAN_IDENTIFIER.ENG_FueRat': 'Kraftstoffverbrauch',
		'ENUM.CAN_IDENTIFIER.ENG_Spe': 'Motordrehzahl',
		'ENUM.CAN_IDENTIFIER.ENG_Tor': 'Motordrehmoment',
		'ENUM.CAN_IDENTIFIER.FHitch_Pos': 'Hubwerkstellung vorne',
		'ENUM.CAN_IDENTIFIER.FPTO_Eng': 'Zapfwelle vorne aktiv',
		'ENUM.CAN_IDENTIFIER.FPTO_Spe': 'Zapfwellendrehzahl vorne',
		'ENUM.CAN_IDENTIFIER.Field_Switch': 'Straße-/Feldschalter',
		'ENUM.CAN_IDENTIFIER.Field_Switch2': 'Straße-/Feldschalter',
		'ENUM.CAN_IDENTIFIER.Front_Draft': 'Zugkraft vorne',
		'ENUM.CAN_IDENTIFIER.Front_NForce': 'Nominelle Zugkraft vorne',
		'ENUM.CAN_IDENTIFIER.GB_Dir': ' Fahrtrichtung über Grund',
		'ENUM.CAN_IDENTIFIER.GB_Speed': 'Geschwindigkeit über Grund',
		'ENUM.CAN_IDENTIFIER.GPS_Speed': 'Geschwindigkeit GPS',
		'ENUM.CAN_IDENTIFIER.Gear_Sel': 'Unimog: Gewählter Gang',
		'ENUM.CAN_IDENTIFIER.GrainCnv_Pos': 'Kornförderung Position',
		'ENUM.CAN_IDENTIFIER.GrainTnk_Lev': 'Füllstand Korntank',
		'ENUM.CAN_IDENTIFIER.HySt_Dir': 'Unimog: Fahrtrichtung Hydrostat',
		'ENUM.CAN_IDENTIFIER.HySt_Mod': 'Unimog: Status Hydrostat',
		'ENUM.CAN_IDENTIFIER.Impl_Work': 'Arbeitszustand Anbaugerät',
		'ENUM.CAN_IDENTIFIER.JbSta': 'SyreN: Job aktiv',
		'ENUM.CAN_IDENTIFIER.Mot_L_Spe': 'Motor (links) Geschwindigkeit',
		'ENUM.CAN_IDENTIFIER.Mot_L_Tor': 'Motor (links) Drehmoment',
		'ENUM.CAN_IDENTIFIER.Mot_R_Spe': 'Motor (rechts) Geschwindigkeit',
		'ENUM.CAN_IDENTIFIER.Mot_R_Tor': 'Motor (rechts) Drehmoment',
		'ENUM.CAN_IDENTIFIER.NO_XTR': 'kein Wert',
		'ENUM.CAN_IDENTIFIER.NUE_abs': 'SyreN: NUE absolute',
		'ENUM.CAN_IDENTIFIER.NUE_rel': 'SyreN: NUE relativ',
		'ENUM.CAN_IDENTIFIER.PHSlu': 'SyreN: Gülle pH-Wert',
		'ENUM.CAN_IDENTIFIER.PTO_Switch': 'Unimog: Getriebeabtrieb N16/N19',
		'ENUM.CAN_IDENTIFIER.PTO_Switch1': 'Unimog: Motorabtrieb N05',
		'ENUM.CAN_IDENTIFIER.PTO_Switch2': 'Unimog: Frontzapfwelle',
		'ENUM.CAN_IDENTIFIER.PTO_Switch3': 'Unimog: Werner Heckzapfwelle',
		'ENUM.CAN_IDENTIFIER.PrxSen': 'IO-Box: Näherungssensor',
		'ENUM.CAN_IDENTIFIER.RHitch_Pos': 'Hubwerkstellung hinten',
		'ENUM.CAN_IDENTIFIER.RPTO_Eng': 'Zapfwelle hinten aktiv',
		'ENUM.CAN_IDENTIFIER.RPTO_Spe': 'Zapfwellendrehzahl hinten',
		'ENUM.CAN_IDENTIFIER.Rear_Draft': 'Zugkraft hinten',
		'ENUM.CAN_IDENTIFIER.Rear_NForce': 'Nominelle Zugkraft hinten',
		'ENUM.CAN_IDENTIFIER.Roll': 'IO-Box: Rollrate',
		'ENUM.CAN_IDENTIFIER.Sli': 'Schlupf',
		'ENUM.CAN_IDENTIFIER.Spe': 'Geschwindigkeit',
		'ENUM.CAN_IDENTIFIER.StrawChop_Pos': 'Position Strohhäcksler',
		'ENUM.CAN_IDENTIFIER.Thresh_Drum': 'Status Dreschtrommel',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A1': 'Reifendruck links A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A2': 'Reifendruck links A2',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A1': 'Reifendruck rechts A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A2': 'Reifendruck rechts A2',
		'ENUM.CAN_IDENTIFIER.UnlAuger_Act': 'Status Entladeschnecke',
		'ENUM.CAN_IDENTIFIER.WB_Dir': 'Fahrtrichtung Rad ',
		'ENUM.CAN_IDENTIFIER.WB_Speed': 'Geschwindigkeit Rad',
		'ENUM.CAN_IDENTIFIER.Xacc': 'IO-Box: Beschleunigung X',
		'ENUM.CAN_IDENTIFIER.Yacc': 'IO-Box: Beschleunigung Y',
		'ENUM.CAN_IDENTIFIER.Yaw': 'IO-Box: Gierrate',
		'ENUM.CAN_IDENTIFIER.Yield_Act': 'Ertrag Erntegut',
		'ENUM.CAN_IDENTIFIER.Yield_Mois': 'Feuchte Erntegut',
		'ENUM.CAN_IDENTIFIER.Zacc': 'IO-Box: Beschleunigung Z',
		'ENUM.COSTPER.h': 'h',
		'ENUM.COSTPER.ha': 'ha',
		'ENUM.COSTPER.km': 'km',
		'ENUM.COSTPER.l': 'l',
		'ENUM.CURRENCY.DOLLAR': '$',
		'ENUM.CURRENCY.EUR': '€',
		'ENUM.CURRENCY.GBP': '£',
		'ENUM.EMPLOYEEROLE.ADMIN': 'Administrator',
		'ENUM.EMPLOYEEROLE.CONSULTANT': 'Berater',
		'ENUM.EMPLOYEEROLE.DISPONENT': 'Disponent',
		'ENUM.EMPLOYEEROLE.DRIVER': 'Fahrer',
		'ENUM.EVENTTYPE.COMMENT': 'Nachricht',
		'ENUM.EVENTTYPE.CT': 'Zähler',
		'ENUM.EVENTTYPE.CT_RS': 'Zähler zurückgesetzt',
		'ENUM.EVENTTYPE.CUSTOMER': 'Kunde',
		'ENUM.EVENTTYPE.EMPL_C_IMPL': 'Mitarbeiter kuppelt Anbaugerät',
		'ENUM.EVENTTYPE.EMPL_E_FIELD': 'Mitarbeiter betritt Feld',
		'ENUM.EVENTTYPE.EMPL_E_MACH': 'Mitarbeiter betritt Maschine',
		'ENUM.EVENTTYPE.EMPL_L_FIELD': 'Mitarbeiter verlässt Feld',
		'ENUM.EVENTTYPE.EMPL_L_MACH': 'Mitarbeiter verlässt Maschine',
		'ENUM.EVENTTYPE.EMPL_P_START': 'Mitarbeiter macht Pause',
		'ENUM.EVENTTYPE.EMPL_P_STOP': 'Mitarbeiter beendet Pause',
		'ENUM.EVENTTYPE.EMPL_UC_IMPL': 'Mitarbeiter entkuppelt Anbaugerät',
		'ENUM.EVENTTYPE.EMPL_W_START': 'Mitarbeiter startet Arbeit',
		'ENUM.EVENTTYPE.EMPL_W_STOP': 'Mitarbeiter beendet Arbeit',
		'ENUM.EVENTTYPE.GTO70': 'Korntank > 70%',
		'ENUM.EVENTTYPE.JOBINFO': 'Job Info',
		'ENUM.EVENTTYPE.JOB_PAUSE': 'Job Pause',
		'ENUM.EVENTTYPE.JOB_RESUME': 'Job fortsetzen',
		'ENUM.EVENTTYPE.JOB_START': 'Job Start',
		'ENUM.EVENTTYPE.JOB_STOP': 'Job Ende',
		'ENUM.EVENTTYPE.L_IMPL': 'Anbaugerät beladen',
		'ENUM.EVENTTYPE.REFUELING': 'Tanken',
		'ENUM.EVENTTYPE.SYREN_CUSTOMER': 'SyreN Kunde',
		'ENUM.EVENTTYPE.SYREN_FIELD': 'SyreN Feld',
		'ENUM.EVENTTYPE.SYREN_SLURRY_TYPE': 'SyreN Gülletype',
		'ENUM.EVENTTYPE.T2_ON': 'Adapter online',
		'ENUM.EVENTTYPE.UL_IMPL': 'Anbaugerät entladen',
		'ENUM.EVENTTYPE.WEATHER': 'Wetter',
		'ENUM.EVENTTYPE.WEIGHING': 'Wiegen',
		'ENUM.EVENTTYPE.WEIGHING_TARA': 'Wiegen (Tara)',
		'ENUM.ISO_TASKDATA_STATE.CRE': 'erstellt',
		'ENUM.ISO_TASKDATA_STATE.ONM': 'auf Maschine',
		'ENUM.ISO_TASKDATA_STATE.RDY': 'Fertig',
		'ENUM.JOBGENERATIONSTATE.ARC': 'Archiviert',
		'ENUM.JOBGENERATIONSTATE.DEL': 'Wird gelöscht',
		'ENUM.JOBGENERATIONSTATE.EDT': 'Wird editiert',
		'ENUM.JOBGENERATIONSTATE.GEN': 'Neuberechnung',
		'ENUM.JOBGENERATIONSTATE.MER': 'Wird zusammengeführt',
		'ENUM.JOBGENERATIONSTATE.QUE': 'in Warteschlange',
		'ENUM.JOBGENERATIONSTATE.READY': 'OK',
		'ENUM.JOBGENERATIONSTATE.REGEN': 'Neuberechnung',
		'ENUM.JOBGENERATIONSTATE.SPLT': 'Wird getrennt',
		'ENUM.JOBGENERATIONSTATE.UPD': 'Wird aktualisiert',
		'ENUM.LOCATIONTYPE.FARM': 'Hof',
		'ENUM.LOCATIONTYPE.FUEL': 'Tankstelle',
		'ENUM.LOCATIONTYPE.OTHERS': 'Andere',
		'ENUM.LOCATIONTYPE.STABLE': 'Stall',
		'ENUM.LOCATIONTYPE.WEIGHING': 'Waage',
		'ENUM.MACHINETYPE.COMBINE': 'Mähdrescher',
		'ENUM.MACHINETYPE.EXCAVATOR': 'Bagger',
		'ENUM.MACHINETYPE.FORAGE_HARVESTER': 'Feldhäcksler',
		'ENUM.MACHINETYPE.MISC': 'Sonstige',
		'ENUM.MACHINETYPE.SELF_PROPELLED': 'Selbstfahrer',
		'ENUM.MACHINETYPE.SYREN': 'SyreN',
		'ENUM.MACHINETYPE.TELEHANDLER': 'Teleskoplader',
		'ENUM.MACHINETYPE.TRACTOR': 'Traktor',
		'ENUM.MACHINETYPE.TRUCK': 'LKW',
		'ENUM.MACHINETYPE.WHEELLOADER': 'Radlader',
		'ENUM.MSGUNIT.-': '-',
		'ENUM.MSGUNIT.AXLES': 'Anzahl Achsen',
		'ENUM.MSGUNIT.CUBIC_M': 'm³',
		'ENUM.MSGUNIT.DOLLAR': '$',
		'ENUM.MSGUNIT.EURO': '€',
		'ENUM.MSGUNIT.KG': 'kg',
		'ENUM.MSGUNIT.LITER': 'l',
		'ENUM.MSGUNIT.TONS': 't',
		'ENUM.MSGUNIT.h': 'h',
		'ENUM.MSGUNIT.ha': 'ha',
		'ENUM.MSGUNIT.km': 'km',
		'ENUM.ONLY_ON_STATE.A': 'Immer',
		'ENUM.ONLY_ON_STATE.F': 'Feld',
		'ENUM.ONLY_ON_STATE.L': 'Ort',
		'ENUM.ONLY_ON_STATE.R': 'Straße',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_1200': 'AgLeader InCommand 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_800': 'AgLeader InCommand 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INTEGRA': 'AgLeader Integra',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_VERSA': 'AgLeader Versa',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD': 'Amazone Amapad',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD_2': 'Amazone Amapad 2',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_3': 'Amazone Amatron 3',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_4': 'Amazone Amatron 4',
		'ENUM.TRACTOR_TERMINAL_TYPE.AN_L10I': 'Andeo L10i',
		'ENUM.TRACTOR_TERMINAL_TYPE.A_XY': 'A_XY',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_1200': 'Case AFS Pro 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_700': 'Case AFS Pro 700',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_1200': 'CCI 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_800': 'CCI 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_CEMIS_1200': 'Claas Cemis 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S10': 'Claas S10',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S7': 'Claas S7',
		'ENUM.TRACTOR_TERMINAL_TYPE.C_S2034': 'C_S2034',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_ONE': 'Fendt One',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_VARIOTERMINAL_10_4': 'Fendt Varioterminal 10.4',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_2630': 'John Deere 2630',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_GEN4': 'John Deere Gen4',
		'ENUM.TRACTOR_TERMINAL_TYPE.KV_TELLUS': 'Kverneland Tellus',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME': 'Müller Elektronik Basic',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_COMFORT': 'Müller Elektronik Comfort',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_1200': 'Müller Elektronik Touch 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_800': 'Müller Elektronik Touch 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.MF_DATATRONIC_5': 'MF Datatronic 5',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR12': 'Raven CR12',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR7': 'Raven CR7',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_VIPER4': 'Raven Viper4',
		'ENUM.TRACTOR_TERMINAL_TYPE.RH_SMART_COMMAND': 'Reichhardt Smart Command',
		'ENUM.TRACTOR_TERMINAL_TYPE.SDF_IMONITOR3': 'SDF iMonitor3',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X25': 'Topcon x25',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X30': 'Topcon x30',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X35': 'Topcon x35',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_XD': 'Topcon XD',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_1260': 'Trimble GFX 1260',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_750': 'Trimble GFX 750',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_TMX_2050': 'Trimble TMX 2050',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_1': 'Typ 1 (schreibt auf USB Stick)',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_2': 'Typ 2 (schreibt nicht auf USB Stick)',
		'ENUM.TRANSPORTUNIT.-': '-',
		'ENUM.TRANSPORTUNIT.AXLES': 'Anzahl Achsen',
		'ENUM.TRANSPORTUNIT.BALE': 'Ballen',
		'ENUM.TRANSPORTUNIT.CUBIC_M': 'm³',
		'ENUM.TRANSPORTUNIT.KG': 'kg',
		'ENUM.TRANSPORTUNIT.LITER': 'l',
		'ENUM.TRANSPORTUNIT.TONS': 't',
		'ENUM.USERROLE.ADMIN': 'Administrator',
		'ENUM.USERROLE.ENTERPRISE': 'Betrieb',
		'ENUM.USERROLE.SALES_FORCE_TECH': 'Tech. Saleforce',
		'ENUM.USERROLE.TRAN': 'Übersetzung',
		'ENUM.USERROLE.USER': 'Benutzer',
		'ENUM.USERROLE.USER_EMPL': 'Benutzer (Enterprise)',
		'ENUM.USERSTATE.ACTIVE': 'Aktiv',
		'ENUM.USERSTATE.DISABLED': 'Gesperrt',
		'ENUM.USERSTATE.NOT_VERIFIED': 'Nicht verifiziert',
		'ENUM.WORKSTATE.DRIVING': 'Fahren',
		'ENUM.WORKSTATE.DRIVING_MISC': 'Wartezeit Fahren',
		'ENUM.WORKSTATE.MISC_FIELD': 'Wartezeit Feld',
		'ENUM.WORKSTATE.MISC_FIELD_GTF': 'Korntank voll',
		'ENUM.WORKSTATE.MISC_ROAD': 'Wartezeit Straße',
		'ENUM.WORKSTATE.PAUSE': 'Pause',
		'ENUM.WORKSTATE.PREPARATION': 'Vorbereitung',
		'ENUM.WORKSTATE.ROAD': 'Straße',
		'ENUM.WORKSTATE.THRESHING': 'Dreschen',
		'ENUM.WORKSTATE.THRESHING_U': 'Entladen beim Dreschen',
		'ENUM.WORKSTATE.THRESHING_W_SC': 'Dreschen mit Strohhäcksler',
		'ENUM.WORKSTATE.THRESHING_W_SC_U': 'Entladen beim Dreschen mit Strohhäcksler',
		'ENUM.WORKSTATE.TRANSPORT_LOADED': 'Lastfahrt',
		'ENUM.WORKSTATE.TRANSPORT_LOADED_MISC': 'Beladen Warten',
		'ENUM.WORKSTATE.TRANSPORT_LOADING': 'Beladen',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED': 'Leerfahrt',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED_MISC': 'Unbeladen Warten',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING': 'Entladen',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING_DRIV': 'Entladen beim Fahren',
		'ENUM.WORKSTATE.TURNING': 'Wenden',
		'ENUM.WORKSTATE.UNDEFINED': 'undefiniert',
		'ENUM.WORKSTATE.WORKING': 'Arbeiten',
		'ENUM.WORKSTATE.WORKING_MISC': 'Wartezeit Arbeiten',
		'ERROR.NO_GPS_DATA': 'Es gibt keine GPS Daten zu der ausgewählten Maschine',
		'ERROR_MESSAGE': 'Fehlermeldung',
		'EVENTS': 'Ereignisse',
		'EVENTS.FIELD': 'Ereignisse auf Feld',
		'EVENTS.NO': 'Keine Events',
		'EXA_ADAPTERS': 'Adapter',
		'EXA_ADAPTERS.AR_ACTIVATE': 'Adapter in Agrirouter aktivieren',
		'EXA_ADAPTERS.AR_DEACTIVATE': 'Adapter in Agrirouter entfernen',
		'EXA_ADAPTERS.AR_LINK_SUCCESS': 'Adapter in Agrirouter aktiviert',
		'EXA_ADAPTERS.AR_UNLINK_SUCCESS': 'Adapter aus Agrirouter entfernt',
		'EXCEPTION.1': 'Interner Server Fehler!',
		'EXCEPTION.100': 'Enumwert nicht gueltig!',
		'EXCEPTION.1000': 'Benutzername darf nicht leer sein!',
		'EXCEPTION.10000': 'Dateiname darf nicht leer sein!',
		'EXCEPTION.10001': 'Datenfeld darf nicht leer sein!',
		'EXCEPTION.10002': 'Datenformat ist nicht gültig!',
		'EXCEPTION.10003': 'Ungültige Anfrage!',
		'EXCEPTION.10004': 'Keine Rohdaten vorhanden!',
		'EXCEPTION.1001': 'Benutzername zu kurz!',
		'EXCEPTION.1002': 'Benutzername ist schon vorhanden!',
		'EXCEPTION.1003': 'Ungültige E-Mail Adresse!',
		'EXCEPTION.1004': 'E-Mail Adresse ist bereits vorhanden!',
		'EXCEPTION.1005': 'Passwort zu kurz!',
		'EXCEPTION.1007': 'Aktivierungscode ist ungültig!',
		'EXCEPTION.1008': 'E-Mail Adresse oder Benutzername nicht bekannt!',
		'EXCEPTION.101': 'Unzulässige Rolle für Mitarbeiter!',
		'EXCEPTION.1011': 'Der Benutzer existiert nicht!',
		'EXCEPTION.1012': 'Der Benutzer ist gelöscht worden!',
		'EXCEPTION.1013': 'Der Benutzer ist nicht aktiv!',
		'EXCEPTION.1014': 'Der Benutzer ist gesperrt!',
		'EXCEPTION.1015': 'Der Benutzer ist noch nicht aktiviert!',
		'EXCEPTION.1016': 'Der Benutzer ist ein Kundenaccount',
		'EXCEPTION.102': 'Unbekannte Währung!',
		'EXCEPTION.1020': 'Der Benutzer existiert bereits!',
		'EXCEPTION.1021': 'Es existiert bereits ein Benutzeraccount mit dieser E-Mail Adresse!',
		'EXCEPTION.1022': 'Ihre E-Mail Adresse wurde nicht geändert!',
		'EXCEPTION.1023': 'Das eingegebene Passwort stimmt nicht!',
		'EXCEPTION.1024': 'Benutzername ist bereits vorhanden!',
		'EXCEPTION.1025': 'Benutzer und Aktivierungscode passen nicht zueinander!',
		'EXCEPTION.1026': 'Benutzername/E-Mail Adresse ungültig!',
		'EXCEPTION.1027': 'Der Benutzer ist bereits aktiviert!',
		'EXCEPTION.1028': 'Nicht erlaubt für Accounts, die von einem Betrieb erstellt wurden!',
		'EXCEPTION.103': 'Transporteinheit nicht bekannt!',
		'EXCEPTION.104': 'Ortstyp ungültig!',
		'EXCEPTION.105': 'Einheit der Kosten ungültig!',
		'EXCEPTION.106': 'Einheit ungültig!',
		'EXCEPTION.107': 'Ungültiger Maschinentyp!',
		'EXCEPTION.108': 'Ungültiger Mitarbeiter-Status!',
		'EXCEPTION.11000': 'Ungültiger Datentyp!',
		'EXCEPTION.12000': 'Ungültiger Datentyp!',
		'EXCEPTION.12002': 'Seriennummer darf nicht leer sein!',
		'EXCEPTION.12003': 'Zustand ungültig!',
		'EXCEPTION.12004': 'Status ungültig!',
		'EXCEPTION.12006': 'Keine T2-Config vorhanden!',
		'EXCEPTION.12007': 'MAC-Adresse darf nicht leer sein!',
		'EXCEPTION.12008': 'MAC-Adresse ungültig!',
		'EXCEPTION.12009': 'Adapter existiert bereits!',
		'EXCEPTION.12010': 'Ungültiger Adapter-Typ!',
		'EXCEPTION.15000': 'Startzeit darf nicht leer sein oder in der Zukunft liegen!',
		'EXCEPTION.15001': 'Stopzeit darf nicht leer sein oder in der Zukunft liegen!',
		'EXCEPTION.15002': 'Stop-Zeit muss vor Startzeit liegen!',
		'EXCEPTION.15003': 'SiloPackage kann nicht generiert werden - keine RawData vorhanden!',
		'EXCEPTION.15004': 'RawData zu alt!',
		'EXCEPTION.16000': 'Name darf nicht leer sein!',
		'EXCEPTION.16001': 'Zugeordneter Kunde existiert nicht!',
		'EXCEPTION.16002': 'Markerliste darf nicht leer sein!',
		'EXCEPTION.16003': 'Markerliste muss mindestens 3 Marker enthalten!',
		'EXCEPTION.16004': 'Fläche darf nicht \"0\" sein!',
		'EXCEPTION.16005': 'Marker-Typ unbekannt!',
		'EXCEPTION.16006': 'Dieses Feld wurde in der ausgewählten Fahrt nicht bearbeitet!',
		'EXCEPTION.16007': 'Rastergrösse darf maximal halb so groß wie Breite und Höhe des Feldes sein!',
		'EXCEPTION.16008': 'Keine Daten zum Interpolieren vorhanden!',
		'EXCEPTION.16009': 'Es kann keine Karte erstellt werden. Alle Datenpunkte beinhalten den selben Wert!',
		'EXCEPTION.17000': 'Name darf nicht leer sein',
		'EXCEPTION.17001': 'Kontaktperson darf nicht leer sein',
		'EXCEPTION.17002': 'Telefonnummer darf nicht leer sein',
		'EXCEPTION.17003': 'E-Mail Adresse darf nicht leer sein',
		'EXCEPTION.17004': 'Ungültige E-Mail Adresse',
		'EXCEPTION.17005': 'Adresse darf nicht leer sein',
		'EXCEPTION.17006': 'PLZ darf nicht leer sein',
		'EXCEPTION.17007': 'Stadt darf nicht leer sein',
		'EXCEPTION.17008': 'Ungültige Farbe ((AA)RRGGBB)',
		'EXCEPTION.18000': 'Typ ungültig',
		'EXCEPTION.19001': 'Typ ungültig',
		'EXCEPTION.19002': 'MAC-Adresse darf nicht leer sein!',
		'EXCEPTION.19003': 'MAC-Adresse ungültig!',
		'EXCEPTION.19004': 'Power darf nicht kleiner 0 sein',
		'EXCEPTION.19007': 'Arbeitnehmer muss gesetzt sein!',
		'EXCEPTION.19008': 'Der Beacon ist kein Implement-Beacon!',
		'EXCEPTION.19009': 'Der Beacon ist kein Fahrer-Beacon!',
		'EXCEPTION.2': 'Doppelter Eintrag!',
		'EXCEPTION.200': 'Error parsing Json Object Type!',
		'EXCEPTION.2000': 'Es konnte kein Authentifizierungsode generiert werden!',
		'EXCEPTION.20000': 'Zu wenig Rohdaten!',
		'EXCEPTION.20001': 'Fehler beim Erstellen der Archiv-Datei!',
		'EXCEPTION.20002': 'Fehler beim Laden der Archiv-Daten!',
		'EXCEPTION.2001': 'Authentifizierungscode existiert nicht!',
		'EXCEPTION.2002': 'Authentifizierungscode ist ungültig!',
		'EXCEPTION.201': 'Error writing Object Type to Json!',
		'EXCEPTION.21000': 'Betriebsname darf nicht leer sein!',
		'EXCEPTION.21001': 'Betriebsname existiert bereits!',
		'EXCEPTION.21002': 'Betriebsname zu kurz!',
		'EXCEPTION.21003': 'Betriebs-E-Mail Adresse ungültig!',
		'EXCEPTION.21004': 'Zugangstoken Betrieb existiert bereits!',
		'EXCEPTION.21005': 'Betrieb ist gelöscht!',
		'EXCEPTION.21006': 'Betrieb ist deaktiviert!',
		'EXCEPTION.21007': 'Betriebsname ist gesperrt!',
		'EXCEPTION.21008': 'Falscher Betriebs-Typ!',
		'EXCEPTION.22000': 'Keine Fahrten zum Hinzufügen vorhanden!',
		'EXCEPTION.22001': 'Keine Fahrten geändert!',
		'EXCEPTION.23000': 'Enterprise not onboarded!',
		'EXCEPTION.23001': 'Enterprise already onboarded!',
		'EXCEPTION.23002': 'Adapter not onboarded!',
		'EXCEPTION.23003': 'Adapter already onboarded!',
		'EXCEPTION.23004': 'Could not onboard adapter!',
		'EXCEPTION.23005': 'Could not reonboard adapter!',
		'EXCEPTION.23006': 'Could not offboard adapter!',
		'EXCEPTION.23007': 'Publishing vCU capabilities failed!',
		'EXCEPTION.23008': 'Publishing vCU data failed!',
		'EXCEPTION.23009': 'Publishing vCU device description failed!',
		'EXCEPTION.23010': 'Publishing Enterprise capabilities failed!',
		'EXCEPTION.23011': 'Es ist ein Problem mit dem agrirouter-Zertifikat aufgetreten. Haben sie das agrirouter-Zertifikat erneuert?',
		'EXCEPTION.24000': 'Betriebsname darf nicht leer sein!',
		'EXCEPTION.24001': 'Betriebsname existiert bereits!',
		'EXCEPTION.24002': 'Betriebsname zu kurz!',
		'EXCEPTION.24003': 'Betriebs-E-Mail Adresse ungültig!',
		'EXCEPTION.24004': 'Betriebs-Zugangscode existiert bereits!',
		'EXCEPTION.24005': 'Betrieb ist gelöscht!',
		'EXCEPTION.24006': 'Betrieb ist deaktiviert!',
		'EXCEPTION.24007': 'Betriebsname ist gesperrt!',
		'EXCEPTION.25000': 'Function not available for selected partner.',
		'EXCEPTION.25001': 'Synchronizing fields failed!',
		'EXCEPTION.25002': 'Synchronizing machines failed!',
		'EXCEPTION.25003': 'Synchronizing implements failed!',
		'EXCEPTION.25004': 'Getting machine failed!',
		'EXCEPTION.25005': 'Creating machine failed!',
		'EXCEPTION.25006': 'Updating machine failed!',
		'EXCEPTION.25007': 'Deleting machine failed!',
		'EXCEPTION.25008': 'Getting implement failed!',
		'EXCEPTION.25009': 'Creating implement failed!',
		'EXCEPTION.25010': 'Updating implement failed!',
		'EXCEPTION.25011': 'Deleting implement failed!',
		'EXCEPTION.26000': 'Fehler beim Erstellen des PDF-Dokuments aufgetreten!',
		'EXCEPTION.26001': 'Die ausgewählte Fahrt ist nicht von einer SyreN-Maschine!',
		'EXCEPTION.27000': 'Maschine unterstützt keinen Dateitransfer!',
		'EXCEPTION.27001': 'Fehler beim Erstellen der Datei!',
		'EXCEPTION.27002': 'Fehler beim Laden der Datei!',
		'EXCEPTION.27003': 'Der ausgewählten Maschine ist kein Adapter zugewiesen!',
		'EXCEPTION.27004': 'Feld \"Name\" ist leer!',
		'EXCEPTION.27005': 'Feld \"Geplantes Datum\" muss gesetzt sein!',
		'EXCEPTION.27006': '\"Geplantes Datum\" nicht korrekt! (darf nur in der Zukunft liegen)',
		'EXCEPTION.27007': 'Status muss gesetzt sein!',
		'EXCEPTION.27008': 'Keine Datei ausgewählt!',
		'EXCEPTION.27009': 'Dateiname muss gesetzt sein!',
		'EXCEPTION.27010': 'Datum muss gesetzt sein!',
		'EXCEPTION.27011': 'Datum ungültig! (darf nur in der Zukunft liegen)',
		'EXCEPTION.27012': 'Größe darf nicht kleiner als 1 sein!',
		'EXCEPTION.27013': 'TaskData Operation nicht möglich mit aktuellen Status',
		'EXCEPTION.27014': 'Filename wird schon genutzt',
		'EXCEPTION.27015': 'Aktuell gibt es keine offenen Tasks',
		'EXCEPTION.27016': 'Es kann nur eine nicht heruntergeladene Datei geben!',
		'EXCEPTION.28001': 'Dateiformat wird nicht unterstützt!',
		'EXCEPTION.29000': 'Update not allowed -> already processed',
		'EXCEPTION.29001': 'No machine or implement given',
		'EXCEPTION.29002': 'Only machine OR implement allowed',
		'EXCEPTION.29003': 'Base value has to be greater than zero',
		'EXCEPTION.29004': 'Warn value has to be greater than zero',
		'EXCEPTION.29005': 'Due value has to be greater than zero',
		'EXCEPTION.29006': 'Due interval has to be greater than warn interval',
		'EXCEPTION.3000': 'Benutzername/Email oder Passwort oder Authentifizierungscode ist falsch!',
		'EXCEPTION.3001': 'Ihr Konto ist gesperrt!',
		'EXCEPTION.3002': 'Ihr Konto ist nicht freigeschaltet!',
		'EXCEPTION.3003': 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
		'EXCEPTION.3004': 'Ein anderer Benutzer hat sich mit dem selben Account eingeloggt!',
		'EXCEPTION.31000': 'App not supported by this operation',
		'EXCEPTION.4000': 'Hersteller darf nicht leer sein!',
		'EXCEPTION.4001': 'Modell darf nicht leer sein!',
		'EXCEPTION.4002': 'Baujahr darf nicht vor 1950 oder in der Zukunft liegen!',
		'EXCEPTION.4003': 'Der Kostensatz darf nicht 0 oder negativ sein!',
		'EXCEPTION.4004': 'Die Betriebsstunden dürfen nicht < 0 sein!',
		'EXCEPTION.4005': 'Der Kilometerstand darf nicht < 0 sein!',
		'EXCEPTION.4007': 'Die Arbeitsbreite darf nicht negativ sein!',
		'EXCEPTION.4008': 'Farbe ungültig! ((AA)RRGGBB)',
		'EXCEPTION.4009': 'XtrCanValuesConfig beinhaltet nicht valide Daten!',
		'EXCEPTION.401': 'Sie sind nicht angemeldet!',
		'EXCEPTION.4010': 'Zu viele Config-Werte!',
		'EXCEPTION.4011': 'Dynamische Config beinhaltet nicht valide Daten',
		'EXCEPTION.4012': 'Maschine ist kein Traktor!',
		'EXCEPTION.4013': 'Die maximale Anzahl an Lizenzen ist bereits belegt!',
		'EXCEPTION.4014': 'Datum darf nicht in der Zukunft liegen!',
		'EXCEPTION.4015': 'Überschreibendes Geschwindigkeitssignal nicht korrekt!',
		'EXCEPTION.403': 'Sie haben keinen Zugriff!',
		'EXCEPTION.450': 'Command error',
		'EXCEPTION.451': 'Benötigte Lizenz nicht vorhanden!',
		'EXCEPTION.452': 'Filter-Parameter ungültig!',
		'EXCEPTION.5000': 'Hersteller darf nicht leer sein!',
		'EXCEPTION.5001': 'Modell darf nicht leer sein!',
		'EXCEPTION.5002': 'Baujahr darf nicht vor 1950 sein oder in der Zukunft liegen!',
		'EXCEPTION.5003': 'Typ 1 darf nicht leer sein!',
		'EXCEPTION.5004': 'Typ 2 ungültig!',
		'EXCEPTION.5005': 'Der Kostensatz darf nicht 0 oder negativ sein!',
		'EXCEPTION.5006': 'Die Arbeitsbreite darf nicht negativ sein!',
		'EXCEPTION.5007': 'Die Transportkapazität darf nicht negativ sein!',
		'EXCEPTION.5008': 'Transport-Einheit ungültig!',
		'EXCEPTION.5009': 'Typ 3 ungültig!',
		'EXCEPTION.5010': 'Ungültige Typ-Kombination!',
		'EXCEPTION.5011': 'Accounting identifier invalid',
		'EXCEPTION.6000': 'Typ unbekannt!',
		'EXCEPTION.6001': 'Radius darf nicht leer oder negativ sein!',
		'EXCEPTION.6002': 'Name darf nicht leer sein!',
		'EXCEPTION.6003': 'Markerliste darf nicht leer sein!',
		'EXCEPTION.6004': 'Markerliste muss mindestens 3 Marker enthalten!',
		'EXCEPTION.6005': 'Marker-Typ unbekannt!',
		'EXCEPTION.6006': 'Waagen-Typ unbekannt!',
		'EXCEPTION.700': 'VarName ungültig',
		'EXCEPTION.7001': 'Konto existiert nicht!',
		'EXCEPTION.7002': 'Ihr Konto ist gesperrt!',
		'EXCEPTION.701': 'Formel ungültig!',
		'EXCEPTION.702': 'CANIdName ungültig',
		'EXCEPTION.703': 'Bedingung ungültig!',
		'EXCEPTION.704': 'VarName ungültig',
		'EXCEPTION.705': 'Ungültige Zustandsparameter!',
		'EXCEPTION.706': 'Workstate ungültig für ImplementTyp',
		'EXCEPTION.707': 'Erstellen der Datei fehlgeschlagen!',
		'EXCEPTION.800': 'Invalid ConfigValue name!',
		'EXCEPTION.8000': 'Arbeitgeber muss gesetzt sein!',
		'EXCEPTION.8001': 'Arbeitnehmer muss gesetzt sein!',
		'EXCEPTION.8002': 'Mitarbeiter für Betrieb nicht gefunden',
		'EXCEPTION.8003': 'Die Kosten duerfen nicht negativ sein!',
    'EXCEPTION.8004': 'Maximale Anzahl an Benutzerlizenzen',
		'EXCEPTION.8005': 'Nicht ihr Arbeitgeber',
		'EXCEPTION.8006': 'Angestellter existiert bereits',
		'EXCEPTION.8007': 'Access Token darf nicht leer sein',
		'EXCEPTION.8008': 'Access Token ist nicht gültig',
		'EXCEPTION.8009': 'In einem Betrieb muss mindestens ein Admin vorhanden sein',
		'EXCEPTION.8010': 'Der Benutzer kann nur mit dem Betrieb verbunden sein, der ihn erstellt hat',
		'EXCEPTION.900': 'Existiert nicht',
		'EXCEPTION.9000': 'Startzeit darf nicht leer sein oder in der Zukunft liegen',
		'EXCEPTION.9001': 'Stopzeit darf nicht leer sein oder in der Zukunft liegen',
		'EXCEPTION.9002': 'Stopzeit kann nicht gleich oder vor Startzeit liegen',
		'EXCEPTION.9003': 'Driver ist kein Angestellter von Job Owner',
		'EXCEPTION.9004': 'Implement gehoert nicht dem Job Owner',
		'EXCEPTION.9005': 'Type1 nicht valide',
		'EXCEPTION.9006': 'Type2 nicht valide',
		'EXCEPTION.9007': 'Type3 nicht valide',
		'EXCEPTION.9008': 'Job kann nicht generiert werden - keine RawData vorhanden',
		'EXCEPTION.9009': 'Maschinen Besitzer und Implement Besitzer stimmen nicht überein',
		'EXCEPTION.901': 'Existiert bereits',
		'EXCEPTION.9010': 'Job existiert bereits',
		'EXCEPTION.9012': 'Job ist noch nicht bereit!',
		'EXCEPTION.9013': 'Job wird gelöscht!',
		'EXCEPTION.9014': 'Job ist archiviert und beinhaltet keine JobLocations!',
		'EXCEPTION.9015': 'RawData zu alt',
		'EXCEPTION.9016': 'Mindestens ein Job ist Teil eines Task',
		'EXCEPTION.9017': 'Jobs stimmen nicht ueberein (Maschine,Fahrer,Implement,Task müssen gleich sein)',
		'EXCEPTION.9018': 'Jobs liegen zu weit auseinander',
		'EXCEPTION.9019': 'Einer der Jobs ist Teil eines Task',
		'EXCEPTION.902': 'Besitzer existiert nicht',
		'EXCEPTION.9020': 'Keine SplitTimes vorhanden',
		'EXCEPTION.9021': 'Job Splittime liegt nicht zwischen Start- und Stopzeit des Jobs',
		'EXCEPTION.9022': 'Kein JobIds zum Mergen',
		'EXCEPTION.9023': 'Mehr als ein Job benötigt',
		'EXCEPTION.9024': 'Punkte Dichte muss > 0 und <= 1 sein',
		'EXCEPTION.903': 'Object mit der Id existiert nicht',
		'EXCEPTION.904': 'Latitude muss sich zwischen -90 und +90 befinden',
		'EXCEPTION.905': 'Longitude muss sich zwischen -180 und +180 befinden',
		'EXCEPTION.906': 'Besitzer stimmen nicht überein',
		'EXCEPTION.907': 'Parameter nicht gesetzt',
		'EXCEPTION.99': 'Parameter ungültig',
		'EXPORT': 'Exportieren',
		'EXPORT.FILTERED_JOBS': 'Alle gefilterten Jobs exportieren',
		'EXPORT.JOB_DETAILS': 'Job Details exportieren',
		'EXPORT.OPERATIONS.CUSTOMER.PERIOD': 'Alle Fahrten für den Kunden im ausgewählten Zeitraum exportieren',
		'EXPORT.OPERATIONS.FIELDS.PERIOD': 'Alle Fahrten auf den Feldern im ausgewählten Zeitraum exportieren',
		'EXPORT.OPERATIONS.LOCATIONS.PERIOD': 'Alle Fahrten auf den Orten im ausgewählten Zeitraum exportieren',
		'EXPORT.POINTS': 'Datenpunkte',
		'EXPORT.POLYGONS': 'Polygone',
		'EXPORT.RAW_DATA_AS_SILO': 'Rohdaten des Jobs als SILO-Datei exportieren',
		'EXPORT.SELECTED': 'Ausgewählte exportieren',
		'EXPORT.SELECT_DATA': 'Folgende Informationen sollen im PDF Report enthalten sein:',
		'EXPORT.SELECT_PERIOD': 'Den zu exportierenden Zeitraum auswählen',
		"FERTILIZER": "Dünger",
		'FIELD': 'Feld',
		'FIELD.ADD': 'Feld hinzufügen',
		'FIELD.ADD.SUCCESS': 'Feld erfolgreich hinzugefügt',
		'FIELD.DEACTIVATE.QUESTION': 'Wollen sie das Feld wirklich deaktivieren?',
		'FIELD.DEACTIVATE.SUCCESS': 'Feld erfolgreich deaktiviert',
		'FIELD.DELETE.QUESTION': 'Feld wirklich löschen?',
		'FIELD.DELETE.SUCCESS': 'Feld gelöscht',
		'FIELD.DETAILS': 'Details Feld',
		'FIELD.DRAW.START': 'Feld jetzt in Karte zeichnen!',
		'FIELD.EDIT.SUCCESS': 'Feld erfolgreich angepasst',
		'FIELD.INTERPOLATE': 'Karte Erstellen',
		'FIELD.INTERPOLATED_VALUES': 'Interpolierte Werte',
		'FIELD.INTERPOLATION': 'Kartenwerkzeug',
		'FIELD.INTERPOLATION_SETTINGS': 'Einstellungen Interpolation',
		'FIELD.INTERPOLATION_SETTINGS.FINE': 'Fein',
		'FIELD.INTERPOLATION_SETTINGS.FINE+': 'Sehr Fein',
		'FIELD.INTERPOLATION_SETTINGS.ROUGH': 'Grob',
		'FIELD.INTERPOLATION_SETTINGS.STANDARD': 'Mittel',
		'FIELD.NUMBER': 'Feldnummer',
		'FIELD.PROCESSED': 'Bearbeitete Felder',
		'FIELDS': 'Felder',
		'FIELDS.ALL': 'Feld(er) wurde(n) erfolgreich bearbeitet',
		'FIELDS.DEACTIVATE.FAILURE': 'Nicht alle ausgewählten Felder konnten deaktiviert werden!',
		'FIELDS.DEACTIVATE.QUESTION': 'Wollen sie die Felder wirklich deaktivieren?',
		'FIELDS.DEACTIVATE.SUCCESS': 'Felder erfolgreich deaktiviert',
		'FIELDS.DELETE.FAILURE': 'Einige der Felder konnten nicht gelöscht werden.',
		'FIELDS.DELETE.QUESTION': 'Ausgewählte Felder wirklich löschen?',
		'FIELDS.DELETE.SUCCESS': 'Felder erfolgreich gelöscht',
		'FIELDS.EDIT': 'Felder bearbeiten',
		'FIELDS.IMPORT': 'Felder importieren',
		'FIELDS.IMPORT.ASSIGN_CUSTOMER.QUESTION': 'Soll den zu importierenden Feldern ein Kunde zugeordnet werden?',
		'FIELDS.IMPORT.SHAPE': 'Bitte wählen Sie eine SHAPE-Datei aus.',
		'FIELDS.IMPORT.SUCCESS': 'Felder erfolgreich importiert',
		'FIELDS.MANAGEMENT': 'Felderverwaltung',
		'FIELDS.NO': 'Keine Felder',
		'FIELDS.NOT_SELECTED': 'Keine Felder ausgewählt',
		'FIELDS.REACTIVATE.FAILURE': 'Nicht alle ausgewählten Felder konnten reaktiviert werden!',
		'FIELDS.REACTIVATE.QUESTION': 'Sollen die ausgewählten Felder wirklich reaktiviert werden?',
		'FIELDS.REACTIVATE.SUCCESS': 'Die ausgewählten Felder wurden reaktiviert',
		'FIELDS.SELECT': 'Felder auswählen',
		'FIELDS.SELECTED': 'Felder ausgewählt',
		'FILE': 'Datei',
		'FILE.GENERATING': 'Datei wird erstellt und in Kürze im Dateimanager bereitstehen',
		'FILE.GENERATING.READY': 'Eine neue Datei steht zum Download bereit',
		'FILE.MANAGER': 'Dateimanager',
		'FILE.NO_FILES': 'Keine Dateien vorhanden',
		'FILE.UPLOAD': 'Datei hochladen',
		'FILE_TRANSFER': 'Dateitransfer',
		'FILE_TRANSFER.ADD': 'Datei hinzufügen',
		'FILE_TRANSFER.ADD.SUCCESS': 'Datei erfolgreich hinzugefügt',
		'FILE_TRANSFER.CREATE': 'Datei erstellen',
		'FILE_TRANSFER.DELETE.QUESTION': 'Wollen sie die Datei wirklich löschen?',
		'FILE_TRANSFER.DELETE.SUCCESS': 'Datei erfolgreich gelöscht',
		'FILE_TRANSFER.FINISHED_TASKS': 'Bearbeitete Dateien',
		'FILE_TRANSFER.NO': 'Keine Dateien',
		'FILE_TRANSFER.QUEUED_TASKS': 'Ausstehende Dateien',
		'FILTER': 'Filter',
		'FIRMWARE_VERSION': 'Firmware-Version',
		'FIRSTNAME': 'Vorname',
		'FORMS.FILE_TOO_LARGE': 'Datei ist zu groß',
		'FORMS.NO_PASSWORD_MATCH': 'Passwörter stimmen nicht überein!',
		'FORMS.REQUIRED': 'Erforderlich',
    'FORMS.INVALID_EMAIL': 'Ungültige E-Mail-Adresse',
		'FORMULA': 'Formel',
		'FUEL': 'Kraftstoff',
		'FUEL.CONSUMPTION': 'Kraftstoffverbrauch',
		'FUEL.CONSUMPTION.AREA': 'Kraftstoffverbrauch pro Fläche',
		'FUEL.CONSUMPTION.AVERAGE': 'Kraftstoffverbrauch pro Stunde',
		'FUEL.CONSUMPTION.OVERALL': 'Gesamtverbrauch Kraftstoff',
		'FUEL.CONSUMPTION.TOTAL': 'Kraftstoffverbrauch',
		'FUEL.COST': 'Kraftstoffkosten',
		'FUEL.LEVEL': 'Tankfüllstand',
		'FUEL.PRICE_PER_LITER': 'Kraftstoffpreis pro Liter',
		'FUEL.WARNING': 'Tankfüllstand niedrig!',
		'GENERAL_INSPECTION': 'Hauptuntersuchung',
		'GEOMETRIES.UPDATE': 'Aktualisieren von Feldern und Orten',
		'GEOMETRY.ADD.REGENERATION_NEEDED': 'Die zugrundeliegenden Daten müssen nach dem Hinzufügen einer neuen Geometrie neu berechnet werden, damit diese korrekt angefügt werden kann. Wollen sie die Fahrten jetzt updaten?',
		'GEOMETRY.CLICK_TO_SAVE': 'Tippe auf die Karte, um die Position des Markers festzulegen.',
		'GPS': 'GPS',
		'GPS.GPS': 'Internes GPS',
		'GPS.LP': 'Letzte bekannte Position',
		'GPS.RTK': 'RTK',
		'GPS.RTK_H': 'RTK (hochpräzise)',
		'GPS.STATUS': 'GPS Status',
		'GPS_HITCH_DISTANCE.IMPLEMENT.INFO': 'Zur korrekten Aufzeichnung der Fahrspur ist es notwendig die Distanz zwischen der Anbindung (B) und dem Arbeitspunkt des Anbaugeräts einzutragen. Dazu wird  dieser Abstand gemessen und in cm eingetragen.',
		'GPS_HITCH_DISTANCE.MACHINE.INFO': 'Zur korrekten Aufzeichnung der Fahrspur ist es notwendig die Distanz zwischen dem GPS Empfänger (A) und der Anbindung der Maschine (B) einzutragen. Dazu wird dieser Abstand gemessen und in cm eingetragen.',
		'GPS_TO_HITCH_DISTANCE': 'Distanz GPS/Anbindung',
		'HARDWARE': 'Hardware',
		'HARDWARE.SETUP.PRINT_STICKER': 'Gerätesticker drucken',
		'HARDWARE.SETUP.PRINT_STICKER_PACKAGING': 'Paketsticker drucken',
		'HARDWARE.SETUP.RESET_DEVICE': 'Gerät zurücksetzen',
		'HARDWARE.SETUP.SET_SERIAL': 'Seriennummer setzen',
		'HEADLAND.PASSES': 'Vorgewende Spuren',
    	'HELPER_MODEL_TEXT': 'Modell entsprechend der Eingabe',
		'HINT_MARKERS.SHOW': 'Hinweismarker anzeigen',
		'HITCH_TO_APPLICATION_DISTANCE': 'Distanz Anbindung/Ausbringung',
		'HITCH:INVALID': 'Bitte geben Sie einen gültigen Zahlenwert ein (maximal eine Dezimalstelle, und negative oder positive Werte sind erlaubt).',
		'HOME': 'Willkommen',
		'HOME.CONTACTREPLY1': 'Dann melde Dich gerne telefonisch bei uns unter',
		'HOME.CONTACTREPLY2': 'oder schreib uns eine E-Mail an',
		'HOME.INTRODUCTORY_VIDEOS': 'Einführungsvideos',
		'HOME.NEWSINFO1': 'Alle Neuigkeiten und spannende Informationen rund um das Thema Flottenmanagement und Fahrzeugtracking findest Du auf unserem',
		'HOME.NEWSINFO2': 'oder auf unserer',
		'HOME.PROFILEEXPLANATION': 'Unter \"Mein Profil\" kannst Du Deine persönlichen Daten anpassen, Deine E-Mail und Dein Passwort ändern.',
		'HOME.QUESTIONSYSTEM': 'Hast Du Fragen zu unserem System?',
		'HOME.TITLE': 'Willkommen',
		'HOME.WELCOMEAREA': 'Herzlich willkommen in Deinem Bereich!',
		'IDLE': 'Leerlauf',
		'IGNORE': 'Ignorieren',
		'IMPLEMENT': 'Anbaugerät',
		'IMPLEMENT.ADD': 'Anbaugerät hinzufügen',
		'IMPLEMENT.ADD.SUCCESS': 'Anbaugerät erfolgreich hinzugefügt',
		'IMPLEMENT.CLASS': 'Geräteklasse',
		'IMPLEMENT.DELETE.QUESTION': 'Soll das Anbaugerät wirklich gelöscht werden?',
		'IMPLEMENT.DELETE.SUCCESS': 'Anbaugerät/Anhänger gelöscht',
		'IMPLEMENT.DETAILS': 'Details Anbaugerät',
		'IMPLEMENT.EDIT': 'Anbaugerät bearbeiten',
		'IMPLEMENT.EDIT.SUCCESS': 'Anbaugerät erfolgreich bearbeitet',
		'IMPLEMENT.FIXED': 'Festes Anbaugerät',
		'IMPLEMENT.NO': 'Kein Anbaugerät',
		'IMPLEMENT.PROCESS.0': 'Leerfahrt',
		'IMPLEMENT.PROCESS.1': 'Rundballen pressen',
		'IMPLEMENT.PROCESS.10': 'Walzen',
		'IMPLEMENT.PROCESS.11': 'Säen',
		'IMPLEMENT.PROCESS.12': 'Pflanzen',
		'IMPLEMENT.PROCESS.13': 'Organische Düngung',
		'IMPLEMENT.PROCESS.14': 'Spritzen',
		'IMPLEMENT.PROCESS.15': 'Beregnen',
		'IMPLEMENT.PROCESS.16': 'Mähen',
		'IMPLEMENT.PROCESS.17': 'Wenden',
		'IMPLEMENT.PROCESS.18': 'Transportieren',
		'IMPLEMENT.PROCESS.19': 'Kehren',
		'IMPLEMENT.PROCESS.2': 'Quaderballen pressen',
		'IMPLEMENT.PROCESS.20': 'Schnee räumen',
		'IMPLEMENT.PROCESS.21': 'Salz streuen',
		'IMPLEMENT.PROCESS.22': 'Hacken',
		'IMPLEMENT.PROCESS.23': 'Mineralische Düngung',
		'IMPLEMENT.PROCESS.24': 'Gülle pumpen',
		'IMPLEMENT.PROCESS.25': 'Gülle rühren',
		'IMPLEMENT.PROCESS.26': 'Kartoffeln legen',
		'IMPLEMENT.PROCESS.27': 'Roden',
		'IMPLEMENT.PROCESS.28': 'Separieren',
		'IMPLEMENT.PROCESS.29': 'Dammfräsen',
		'IMPLEMENT.PROCESS.3': 'Presswickeln',
		'IMPLEMENT.PROCESS.30': 'Kraut schlagen',
		'IMPLEMENT.PROCESS.31': 'Schwaden',
		'IMPLEMENT.PROCESS.32': 'Striegeln',
		'IMPLEMENT.PROCESS.33': 'Schleppen',
		'IMPLEMENT.PROCESS.34': 'Mulchen',
		'IMPLEMENT.PROCESS.35': 'Kehren',
		'IMPLEMENT.PROCESS.36': 'Schnee fräsen',
		'IMPLEMENT.PROCESS.37': 'Güllecontainer umsetzen',
		'IMPLEMENT.PROCESS.38': 'Beetformen',
		'IMPLEMENT.PROCESS.39': 'Füttern',
		'IMPLEMENT.PROCESS.4': 'Ballen wickeln',
		'IMPLEMENT.PROCESS.40': 'Holz rücken',
		'IMPLEMENT.PROCESS.41': 'Holz sägen',
		'IMPLEMENT.PROCESS.42': 'Holz spalten',
		'IMPLEMENT.PROCESS.43': 'Baumstumpffräsen',
		'IMPLEMENT.PROCESS.44': 'Schüttgut laden',
		'IMPLEMENT.PROCESS.45': 'Paletten laden',
		'IMPLEMENT.PROCESS.46': 'Ballen laden',
		'IMPLEMENT.PROCESS.47': 'CCM-Mühle umsetzen',
		'IMPLEMENT.PROCESS.48': 'Schieben',
		'IMPLEMENT.PROCESS.49': 'Front-/Heckgewicht',
		'IMPLEMENT.PROCESS.5': 'Pflügen',
		'IMPLEMENT.PROCESS.50': 'Dreschen',
		'IMPLEMENT.PROCESS.51': 'Häckseln',
		'IMPLEMENT.PROCESS.52': 'Hochdruckballen pressen',
		'IMPLEMENT.PROCESS.53': 'Entblättern',
		'IMPLEMENT.PROCESS.54': 'Planieren',
		'IMPLEMENT.PROCESS.55': 'Bodenbearbeitung',
		'IMPLEMENT.PROCESS.56': 'Gehölzpflege',
		'IMPLEMENT.PROCESS.57': 'Pflege-/Montagearbeiten',
		'IMPLEMENT.PROCESS.58': 'Verladen',
		'IMPLEMENT.PROCESS.59': 'Be- und entladen',
		'IMPLEMENT.PROCESS.6': 'Grubbern',
		'IMPLEMENT.PROCESS.60': 'Waschen',
		'IMPLEMENT.PROCESS.61': 'Verdichten',
		'IMPLEMENT.PROCESS.7': 'Eggen',
		'IMPLEMENT.PROCESS.8': 'Tiefgrubbern',
		'IMPLEMENT.PROCESS.9': 'Fräsen',
		'IMPLEMENT.PROCESS.deadhead': 'Leerfahrt',
		'IMPLEMENT.REMOVE': 'Anbaugerät entfernen',
		'IMPLEMENT.RESOURCE.0': 'undefiniert',
		'IMPLEMENT.RESOURCE.1': 'Frischfutter',
		'IMPLEMENT.RESOURCE.10': 'Festmist',
		'IMPLEMENT.RESOURCE.11': 'Gülle',
		'IMPLEMENT.RESOURCE.12': 'Kompost',
		'IMPLEMENT.RESOURCE.13': 'Gärrest',
		'IMPLEMENT.RESOURCE.14': 'Holzhackschnitzel',
		'IMPLEMENT.RESOURCE.15': 'Mais',
		'IMPLEMENT.RESOURCE.16': 'Sonnenblumen',
		'IMPLEMENT.RESOURCE.17': 'Sorghum',
		'IMPLEMENT.RESOURCE.18': 'Roggen',
		'IMPLEMENT.RESOURCE.19': 'Triticale',
		'IMPLEMENT.RESOURCE.2': 'Grassilage',
		'IMPLEMENT.RESOURCE.20': 'Weizen',
		'IMPLEMENT.RESOURCE.21': 'Ackerbohnen',
		'IMPLEMENT.RESOURCE.22': 'Erbsen',
		'IMPLEMENT.RESOURCE.23': 'Feldgras',
		'IMPLEMENT.RESOURCE.24': 'Kleegras',
		'IMPLEMENT.RESOURCE.25': 'Gerste',
		'IMPLEMENT.RESOURCE.26': 'Hafer',
		'IMPLEMENT.RESOURCE.27': 'Dinkel',
		'IMPLEMENT.RESOURCE.28': 'Leindotter',
		'IMPLEMENT.RESOURCE.29': 'Öllein',
		'IMPLEMENT.RESOURCE.3': 'GPS',
		'IMPLEMENT.RESOURCE.30': 'Raps',
		'IMPLEMENT.RESOURCE.31': 'Sojabohnen',
		'IMPLEMENT.RESOURCE.32': 'Zwischenfrüchte',
		'IMPLEMENT.RESOURCE.33': 'Rüben',
		'IMPLEMENT.RESOURCE.34': 'Kartoffeln',
		'IMPLEMENT.RESOURCE.35': 'Miscanthus',
		'IMPLEMENT.RESOURCE.36': 'Topinambur',
		'IMPLEMENT.RESOURCE.37': 'Gemüse',
		'IMPLEMENT.RESOURCE.38': 'Erdbeeren',
		'IMPLEMENT.RESOURCE.39': 'AHL',
		'IMPLEMENT.RESOURCE.4': 'Heu',
		'IMPLEMENT.RESOURCE.40': 'Kalk',
		'IMPLEMENT.RESOURCE.41': 'Diammonphosphat',
		'IMPLEMENT.RESOURCE.42': 'Haarmehlpellets, PK, K, P, KAS',
		'IMPLEMENT.RESOURCE.43': 'Harnstoff',
		'IMPLEMENT.RESOURCE.44': 'Diesel',
		'IMPLEMENT.RESOURCE.45': 'AdBlue',
		'IMPLEMENT.RESOURCE.46': 'Erde',
		'IMPLEMENT.RESOURCE.47': 'Pflanzenschutzmittel',
		'IMPLEMENT.RESOURCE.48': 'Sonstiges',
		'IMPLEMENT.RESOURCE.49': 'Wasser',
		'IMPLEMENT.RESOURCE.5': 'CCM',
		'IMPLEMENT.RESOURCE.50': 'Futtermischung',
		'IMPLEMENT.RESOURCE.6': 'Körnermais',
		'IMPLEMENT.RESOURCE.7': 'Stroh',
		'IMPLEMENT.RESOURCE.8': 'Silagemais',
		'IMPLEMENT.RESOURCE.9': 'Getreide',
		'IMPLEMENT.TYPE': 'Gerätetyp',
		'IMPLEMENT.TYPE.1': 'Pressen/Ballenwickelgeräte',
		'IMPLEMENT.TYPE.10': 'Transportanhänger',
		'IMPLEMENT.TYPE.10_1': '3-Seiten Kipper',
		'IMPLEMENT.TYPE.10_10': 'Tieflader',
		'IMPLEMENT.TYPE.10_11': 'Container-Hakenlift-System',
		'IMPLEMENT.TYPE.10_12': 'Viehwagen',
		'IMPLEMENT.TYPE.10_13': 'Dolly-Achse',
		'IMPLEMENT.TYPE.10_14': 'Tank-/Silofahrzeuge',
		'IMPLEMENT.TYPE.10_2': 'Wannen-/Muldenkipper',
		'IMPLEMENT.TYPE.10_3': 'Überladewagen',
		'IMPLEMENT.TYPE.10_4': 'Plattformwagen',
		'IMPLEMENT.TYPE.10_5': 'Lade-/Silierwagen',
		'IMPLEMENT.TYPE.10_6': 'Häckseltransportwagen',
		'IMPLEMENT.TYPE.10_7': 'Ballentransportwagen',
		'IMPLEMENT.TYPE.10_8': 'Abschiebewagen',
		'IMPLEMENT.TYPE.10_9': 'Gülletransportwagen',
		'IMPLEMENT.TYPE.11': 'Fütterungstechnik',
		'IMPLEMENT.TYPE.11_1': 'Futtermischwagen',
		'IMPLEMENT.TYPE.11_2': 'Futterverteilwagen',
		'IMPLEMENT.TYPE.11_3': 'Entname-/Verteilgerät',
		'IMPLEMENT.TYPE.12': 'Forsttechnik',
		'IMPLEMENT.TYPE.12_1': 'Rückeanhänger',
		'IMPLEMENT.TYPE.12_2': 'Brennholzsäge',
		'IMPLEMENT.TYPE.12_3': 'Brennholzautomat',
		'IMPLEMENT.TYPE.12_4': 'Holzspalter',
		'IMPLEMENT.TYPE.12_5': 'Baumstumpffräse',
		'IMPLEMENT.TYPE.12_6': 'Forstseilwinde',
		'IMPLEMENT.TYPE.12_7': 'Forstmulcher',
		'IMPLEMENT.TYPE.12_8': 'Holzhacker',
		'IMPLEMENT.TYPE.12_8_1': 'Scheibenhacker - angebaut',
		'IMPLEMENT.TYPE.12_8_2': 'Scheibenhacker - angehängt',
		'IMPLEMENT.TYPE.12_8_3': 'Trommelhacker - angebaut',
		'IMPLEMENT.TYPE.12_8_4': 'Trommelhacker - angehängt',
		'IMPLEMENT.TYPE.12_8_5': 'Trommelhacker - angehängt mit eigenem Motor',
		'IMPLEMENT.TYPE.12_9': 'Hydraulische Heckenschere',
		'IMPLEMENT.TYPE.13': 'Kommunaltechnik',
		'IMPLEMENT.TYPE.13_1': 'Kehrmaschinen',
		'IMPLEMENT.TYPE.13_10': 'Wegepflegegerät',
		'IMPLEMENT.TYPE.13_11': 'Bankettfräse',
		'IMPLEMENT.TYPE.13_12': 'Salzstreuer - aufgebaut',
		'IMPLEMENT.TYPE.13_13': 'Ladegeräte',
		'IMPLEMENT.TYPE.13_14': 'Waschgeräte',
		'IMPLEMENT.TYPE.13_15': 'Bewässerungsgeräte',
		'IMPLEMENT.TYPE.13_16': 'Arbeitsbühne',
		'IMPLEMENT.TYPE.13_17': 'Flächenmulcher',
		'IMPLEMENT.TYPE.13_18': 'Ausleger Front',
		'IMPLEMENT.TYPE.13_18_1': 'Mähkopf',
		'IMPLEMENT.TYPE.13_18_2': 'Mulchkopf',
		'IMPLEMENT.TYPE.13_18_3': 'Heckenschere',
		'IMPLEMENT.TYPE.13_18_4': 'Räumkorb',
		'IMPLEMENT.TYPE.13_18_5': 'Schwader',
		'IMPLEMENT.TYPE.13_19': 'Ausleger Mitte/Aufbau',
		'IMPLEMENT.TYPE.13_19_1': 'Mähkopf',
		'IMPLEMENT.TYPE.13_19_2': 'Mulchkopf',
		'IMPLEMENT.TYPE.13_19_3': 'Heckenschere',
		'IMPLEMENT.TYPE.13_19_4': 'Räumkorb',
		'IMPLEMENT.TYPE.13_19_5': 'Schwader',
		'IMPLEMENT.TYPE.13_1_1': 'Frontanbau',
		'IMPLEMENT.TYPE.13_1_2': 'Heckanbau',
		'IMPLEMENT.TYPE.13_1_3': 'Aufbau',
		'IMPLEMENT.TYPE.13_2': 'Schneepflug',
		'IMPLEMENT.TYPE.13_20': 'Ausleger Heck',
		'IMPLEMENT.TYPE.13_20_1': 'Mähkopf',
		'IMPLEMENT.TYPE.13_20_2': 'Mulchkopf',
		'IMPLEMENT.TYPE.13_20_3': 'Heckenschere',
		'IMPLEMENT.TYPE.13_20_4': 'Räumkorb',
		'IMPLEMENT.TYPE.13_20_5': 'Schwader',
		'IMPLEMENT.TYPE.13_21': 'Laubsauger',
		'IMPLEMENT.TYPE.13_22': 'Bankettverdichter / Plattenverdichter',
		'IMPLEMENT.TYPE.13_3': 'Schneepflug - Keilpflug',
		'IMPLEMENT.TYPE.13_4': 'Schneefräse',
		'IMPLEMENT.TYPE.13_5': 'Salzstreuer - angebaut',
		'IMPLEMENT.TYPE.13_6': 'Salzstreuer - angehängt',
		'IMPLEMENT.TYPE.13_7': 'Randstreifenmäher',
		'IMPLEMENT.TYPE.13_8': 'Böschungsmäher',
		'IMPLEMENT.TYPE.13_9': 'Mähwerk',
		'IMPLEMENT.TYPE.14': 'Frontladerarbeiten',
		'IMPLEMENT.TYPE.14_1': 'Schaufel',
		'IMPLEMENT.TYPE.14_2': 'Leichtgutschaufel',
		'IMPLEMENT.TYPE.14_3': 'Palettengabel',
		'IMPLEMENT.TYPE.14_4': 'Ballenzange',
		'IMPLEMENT.TYPE.14_5': 'Ballengabel',
		'IMPLEMENT.TYPE.14_6': 'Greifschaufel/-zange',
		'IMPLEMENT.TYPE.14_7': 'Arbeitsbühne',
		'IMPLEMENT.TYPE.14_8': 'Dunggabel',
		'IMPLEMENT.TYPE.15': 'Erntevorsätze',
		'IMPLEMENT.TYPE.15_1': 'Schneidwerk',
		'IMPLEMENT.TYPE.15_1_1': 'Schneidwerk - standard',
		'IMPLEMENT.TYPE.15_1_2': 'Schneidwerk - klappbar',
		'IMPLEMENT.TYPE.15_2': 'Maispflücker',
		'IMPLEMENT.TYPE.15_2_1': 'Maispflücker - standard',
		'IMPLEMENT.TYPE.15_3': 'Maisgebiss',
		'IMPLEMENT.TYPE.15_4': 'GPS-Vorsatz',
		'IMPLEMENT.TYPE.15_5': 'Pick-Up',
		'IMPLEMENT.TYPE.15_6': 'Rodevorsatz',
		'IMPLEMENT.TYPE.15_7': 'Aufnahmesystem',
		'IMPLEMENT.TYPE.15_8': 'Schwadaufnehmer',
		'IMPLEMENT.TYPE.16': 'Sonstiges',
		'IMPLEMENT.TYPE.16_1': 'CCM-Getreidemühlen',
		'IMPLEMENT.TYPE.16_2': 'Frontgewicht',
		'IMPLEMENT.TYPE.16_3': 'Heckgewicht',
		'IMPLEMENT.TYPE.16_4': 'Schiebeschild',
		'IMPLEMENT.TYPE.17': 'Obst-/Weinbau',
		'IMPLEMENT.TYPE.17_1': 'Rodepflug',
		'IMPLEMENT.TYPE.17_2': 'Pflanzmaschine',
		'IMPLEMENT.TYPE.17_3': 'Entlauber',
		'IMPLEMENT.TYPE.17_4': 'Wurzelstockfräse',
		'IMPLEMENT.TYPE.18': 'Gemüsebau',
		'IMPLEMENT.TYPE.18_1': 'Karottenroder',
		'IMPLEMENT.TYPE.18_2': 'Zwiebelroder',
		'IMPLEMENT.TYPE.18_4': 'Blumenzwiebelroder',
		'IMPLEMENT.TYPE.18_5': 'Porreeroder',
		'IMPLEMENT.TYPE.19': 'Zuckerrübentechnik',
		'IMPLEMENT.TYPE.19_1': 'Zuckerrübenroder',
		'IMPLEMENT.TYPE.19_1_1': 'Bunkerroder',
		'IMPLEMENT.TYPE.19_1_2': 'Überladeroder',
		'IMPLEMENT.TYPE.1_1': 'Rundballenpresse',
		'IMPLEMENT.TYPE.1_2': 'Quaderballenpresse',
		'IMPLEMENT.TYPE.1_3': 'Press-/Wickelkombination',
		'IMPLEMENT.TYPE.1_4': 'Ballenwickelgerät',
		'IMPLEMENT.TYPE.1_5': 'Hochdruckpresse',
		'IMPLEMENT.TYPE.2': 'Bodenbearbeitung',
		'IMPLEMENT.TYPE.2_1': 'Pflug',
		'IMPLEMENT.TYPE.2_10': 'Fräse',
		'IMPLEMENT.TYPE.2_10_1': 'Fräse - angebaut',
		'IMPLEMENT.TYPE.2_10_2': 'Fräse - angehängt',
		'IMPLEMENT.TYPE.2_11': 'Frontpacker',
		'IMPLEMENT.TYPE.2_12': 'Walze',
		'IMPLEMENT.TYPE.2_12_1': 'Walze - angebaut',
		'IMPLEMENT.TYPE.2_12_2': 'Walze - angehängt',
		'IMPLEMENT.TYPE.2_13': 'Spatenrollegge',
		'IMPLEMENT.TYPE.2_13_1': 'Spatenrollegge - angebaut',
		'IMPLEMENT.TYPE.2_13_2': 'Spatenrollegge - angehängt',
		'IMPLEMENT.TYPE.2_14': 'Kreiselgrubber',
		'IMPLEMENT.TYPE.2_14_1': 'Kreiselgrubber - angebaut',
		'IMPLEMENT.TYPE.2_14_2': 'Kreiselgrubber - angehängt',
		'IMPLEMENT.TYPE.2_15': 'Saatbettkombination',
		'IMPLEMENT.TYPE.2_15_1': 'Saatbettkombination - angebaut',
		'IMPLEMENT.TYPE.2_15_2': 'Saatbettkombination - angehängt',
		'IMPLEMENT.TYPE.2_16': 'Packer',
		'IMPLEMENT.TYPE.2_17': 'Planiergerät',
		'IMPLEMENT.TYPE.2_17_1': 'Planiergerät - angebaut',
		'IMPLEMENT.TYPE.2_17_2': 'Planiergerät - angehängt',
		'IMPLEMENT.TYPE.2_18': 'Strohstriegel',
		'IMPLEMENT.TYPE.2_18_1': 'Strohstriegel - angebaut',
		'IMPLEMENT.TYPE.2_18_2': 'Strohstriegel - angehängt',
		'IMPLEMENT.TYPE.2_19': 'Sonstige Bodenbearbeitung',
		'IMPLEMENT.TYPE.2_19_1': 'Sonstige Bodenbearbeitung - angebaut',
		'IMPLEMENT.TYPE.2_19_2': 'Sonstige Bodenbearbeitung - angehängt',
		'IMPLEMENT.TYPE.2_1_1': 'Pflug - angebaut',
		'IMPLEMENT.TYPE.2_1_2': 'Pflug - aufgesattelt',
		'IMPLEMENT.TYPE.2_1_3': 'Pflug - aufgesattelt (on land)',
		'IMPLEMENT.TYPE.2_2': 'Grubber',
		'IMPLEMENT.TYPE.2_20': 'Sonstige Bodenbearbeitung',
		'IMPLEMENT.TYPE.2_2_1': 'Grubber - angebaut',
		'IMPLEMENT.TYPE.2_2_2': 'Grubber - aufgesattelt',
		'IMPLEMENT.TYPE.2_3': 'Scheibenegge',
		'IMPLEMENT.TYPE.2_3_1': 'Scheibenegge - angebaut',
		'IMPLEMENT.TYPE.2_3_2': 'Scheibenegge - aufgesattelt',
		'IMPLEMENT.TYPE.2_4': 'Kurzscheibenegge',
		'IMPLEMENT.TYPE.2_4_1': 'Kurzscheibenegge - angebaut',
		'IMPLEMENT.TYPE.2_4_2': 'Kurzscheibenegge - angehängt',
		'IMPLEMENT.TYPE.2_5': 'Tiefenlockerer',
		'IMPLEMENT.TYPE.2_5_1': 'Tiefenlockerer - angebaut',
		'IMPLEMENT.TYPE.2_5_2': 'Tiefenlockerer - angehängt',
		'IMPLEMENT.TYPE.2_6': 'Spatenmaschine',
		'IMPLEMENT.TYPE.2_6_1': 'Spatenmaschine - angebaut',
		'IMPLEMENT.TYPE.2_6_2': 'Spatenmaschine - angehängt',
		'IMPLEMENT.TYPE.2_7': 'Kreiselegge',
		'IMPLEMENT.TYPE.2_7_1': 'Kreiselegge - angebaut',
		'IMPLEMENT.TYPE.2_7_2': 'Kreiselegge - angehängt',
		'IMPLEMENT.TYPE.2_8': 'Zinkenrotor',
		'IMPLEMENT.TYPE.2_8_1': 'Zinkenrotor - angebaut',
		'IMPLEMENT.TYPE.2_8_2': 'Zinkenrotor - angehängt',
		'IMPLEMENT.TYPE.2_9': 'Rüttelegge',
		'IMPLEMENT.TYPE.2_9_1': 'Rüttelegge - angebaut',
		'IMPLEMENT.TYPE.2_9_2': 'Rüttelegge - angehängt',
		'IMPLEMENT.TYPE.3': 'Sä-/Pflanztechnik',
		'IMPLEMENT.TYPE.3_1': 'Sämaschine mechanisch',
		'IMPLEMENT.TYPE.3_1_1': 'Sämaschine - angebaut',
		'IMPLEMENT.TYPE.3_1_2': 'Sämaschine - angehängt',
		'IMPLEMENT.TYPE.3_1_3': 'Säkombination - angebaut',
		'IMPLEMENT.TYPE.3_1_4': 'Säkombination - angehängt',
		'IMPLEMENT.TYPE.3_2': 'Sämaschine pneumatisch',
		'IMPLEMENT.TYPE.3_2_1': 'Sämaschine - angebaut',
		'IMPLEMENT.TYPE.3_2_2': 'Sämaschine - angehängt',
		'IMPLEMENT.TYPE.3_2_3': 'Säkombination - angebaut',
		'IMPLEMENT.TYPE.3_2_4': 'Säkombination - angehängt',
		'IMPLEMENT.TYPE.3_3': 'Einzelkornsämaschine mechanisch',
		'IMPLEMENT.TYPE.3_3_1': 'Sämaschine - angebaut',
		'IMPLEMENT.TYPE.3_3_2': 'Sämaschine - angehängt',
		'IMPLEMENT.TYPE.3_3_3': 'Säkombination - angebaut',
		'IMPLEMENT.TYPE.3_3_4': 'Säkombination - angehängt',
		'IMPLEMENT.TYPE.3_4': 'Einzelkornsämaschine pneumatisch',
		'IMPLEMENT.TYPE.3_4_1': 'Sämaschine - angebaut',
		'IMPLEMENT.TYPE.3_4_2': 'Sämaschine - angehängt',
		'IMPLEMENT.TYPE.3_4_3': 'Säkombination - angebaut',
		'IMPLEMENT.TYPE.3_4_4': 'Säkombination - angehängt',
		'IMPLEMENT.TYPE.3_5': 'Direktsämaschine',
		'IMPLEMENT.TYPE.3_5_1': 'Direktsämaschine angebaut',
		'IMPLEMENT.TYPE.3_5_2': 'Direktsämaschine angehängt',
		'IMPLEMENT.TYPE.3_6': 'Einzelkorn-Direktsämaschine',
		'IMPLEMENT.TYPE.3_6_1': 'Einzelkorn-Direktsämaschine angebaut',
		'IMPLEMENT.TYPE.3_6_2': 'Einzelkorn-Direktsämaschine angehängt',
		'IMPLEMENT.TYPE.3_7': 'Pflanzmaschinen',
		'IMPLEMENT.TYPE.3_7_1': 'Pflanzmaschine - angebaut',
		'IMPLEMENT.TYPE.3_7_2': 'Pflanzmaschine - angehängt',
		'IMPLEMENT.TYPE.3_8': 'Grünlandnachsämaschine',
		'IMPLEMENT.TYPE.3_8_1': 'Grünlandnachsämaschine angebaut',
		'IMPLEMENT.TYPE.3_8_2': 'Grünlandnachsämaschine angehängt',
		'IMPLEMENT.TYPE.3_9': 'Fronttank',
		'IMPLEMENT.TYPE.4': 'Düngetechnik',
		'IMPLEMENT.TYPE.4_1': 'Düngerstreuer - angebaut',
		'IMPLEMENT.TYPE.4_2': 'Düngerstreuer - angehängt',
		'IMPLEMENT.TYPE.5': 'Pflanzenschutztechnik',
		'IMPLEMENT.TYPE.5_1': 'Pflanzenschutzspritze - angebaut',
		'IMPLEMENT.TYPE.5_2': 'Pflanzenschutzspritze - angehängt',
		'IMPLEMENT.TYPE.5_3': 'Hackmaschine',
		'IMPLEMENT.TYPE.5_3_1': 'Hackmaschine angebaut',
		'IMPLEMENT.TYPE.5_3_2': 'Hackmaschine angehängt',
		'IMPLEMENT.TYPE.5_4': 'Hackstriegel',
		'IMPLEMENT.TYPE.5_4_1': 'Hackstriegel angebaut',
		'IMPLEMENT.TYPE.5_4_2': 'Hackstriegel angehängt',
		'IMPLEMENT.TYPE.6': 'Gülle-/Dungtechnik',
		'IMPLEMENT.TYPE.6_1': 'Dung-/Kompoststreuer',
		'IMPLEMENT.TYPE.6_2': 'Güllewagen',
		'IMPLEMENT.TYPE.6_2_1': 'Prallteller',
		'IMPLEMENT.TYPE.6_2_2': 'Schleppschlauchverteiler',
		'IMPLEMENT.TYPE.6_2_3': 'Schleppschuhverteiler',
		'IMPLEMENT.TYPE.6_2_4': 'Injektionsgrubber',
		'IMPLEMENT.TYPE.6_2_5': 'Injektionsscheibenegge',
		'IMPLEMENT.TYPE.6_2_6': 'Grünlandschlitzgerät',
		'IMPLEMENT.TYPE.6_2_7': 'Strip-Till Injektor',
		'IMPLEMENT.TYPE.6_2_8': 'Schwenkverteiler',
		'IMPLEMENT.TYPE.6_3': 'Güllepumpen',
		'IMPLEMENT.TYPE.6_4': 'Güllemixer',
		'IMPLEMENT.TYPE.6_5': 'Güllecontainer',
		'IMPLEMENT.TYPE.6_6': 'Verschlauchungssystem',
		'IMPLEMENT.TYPE.6_6_1': 'Schleppschlauchverteiler',
		'IMPLEMENT.TYPE.6_6_2': 'Schleppschuhverteiler',
		'IMPLEMENT.TYPE.6_6_3': 'Schlitzgerät',
		'IMPLEMENT.TYPE.6_6_4': 'Injektionsgrubber',
		'IMPLEMENT.TYPE.6_6_5': 'Injektionsscheibenegge',
		'IMPLEMENT.TYPE.6_6_6': 'Striptill Injektor',
		'IMPLEMENT.TYPE.6_6_7': 'Schwenkverteiler',
		'IMPLEMENT.TYPE.7': 'Beregnungstechnik',
		'IMPLEMENT.TYPE.7_1': 'Beregnungsmaschine mit Düsenwagen',
		'IMPLEMENT.TYPE.7_2': 'Beregnungsmaschine mit Einzelregner',
		'IMPLEMENT.TYPE.8': 'Kartoffeltechnik',
		'IMPLEMENT.TYPE.8_1': 'Kartoffellegemaschine',
		'IMPLEMENT.TYPE.8_1_1': 'Legemaschine ohne Kreiselegge/Vollfeldfräse',
		'IMPLEMENT.TYPE.8_1_2': 'Legemaschine mit Kreiselegge/Vollfeldfräse',
		'IMPLEMENT.TYPE.8_1_3': 'Legemaschine ohne Kreiselegge/Vollfeldfräse angehängt',
		'IMPLEMENT.TYPE.8_1_4': 'Legemaschine mit Kreiselegge/Vollfeldfräse angebaut',
		'IMPLEMENT.TYPE.8_2': 'Kartoffelroder - Reihenleger',
		'IMPLEMENT.TYPE.8_3': 'Kartoffelroder - Bunkerroder',
		'IMPLEMENT.TYPE.8_4': 'Kartoffelroder - Überladeroder',
		'IMPLEMENT.TYPE.8_5': 'Beetformer',
		'IMPLEMENT.TYPE.8_6': 'Separierer',
		'IMPLEMENT.TYPE.8_7': 'Dammfräse',
		'IMPLEMENT.TYPE.8_8': 'Krautschläger',
		'IMPLEMENT.TYPE.9': 'Grünlandgeräte',
		'IMPLEMENT.TYPE.9_1': 'Trommelmähwerk',
		'IMPLEMENT.TYPE.9_1_1': 'Trommelmähwerk mit Aufbereiter',
		'IMPLEMENT.TYPE.9_1_2': 'Trommelmähwerk ohne Aufbereiter',
		'IMPLEMENT.TYPE.9_1_3': 'Trommelmähwerk mit Aufbereiter angebaut',
		'IMPLEMENT.TYPE.9_1_4': 'Trommelmähwerk ohne Aufbereiter angehängt',
		'IMPLEMENT.TYPE.9_2': 'Balkenmähwerk',
		'IMPLEMENT.TYPE.9_2_1': 'Scheibenmähwerk mit Aufbereiter',
		'IMPLEMENT.TYPE.9_2_2': 'Scheibenmähwerk ohne Aufbereiter',
		'IMPLEMENT.TYPE.9_2_3': 'Scheibenmähwerk mit Aufbereiter angebaut',
		'IMPLEMENT.TYPE.9_2_4': 'Scheibenmähwerk ohne Aufbereiter angehängt',
		'IMPLEMENT.TYPE.9_3': 'Kreiselheuer/-wender',
		'IMPLEMENT.TYPE.9_3_1': 'Kreiselheuer/-wender angebaut',
		'IMPLEMENT.TYPE.9_3_2': 'Kreiselheuer/-wender angehängt',
		'IMPLEMENT.TYPE.9_4': 'Schwader',
		'IMPLEMENT.TYPE.9_4_1': 'Einkreiselschwader',
		'IMPLEMENT.TYPE.9_4_2': 'Zweikreiselschwader mit Seitenablage',
		'IMPLEMENT.TYPE.9_4_3': 'Zweikreiselschwader mit Mittenablage',
		'IMPLEMENT.TYPE.9_4_4': 'Vierkreiselschwader',
		'IMPLEMENT.TYPE.9_4_5': 'Bandschwader',
		'IMPLEMENT.TYPE.9_4_6': 'Sternrechenschwader',
		'IMPLEMENT.TYPE.9_5': 'Wiesenstriegel',
		'IMPLEMENT.TYPE.9_6': 'Wiesenschleppe',
		'IMPLEMENT.TYPE.9_7': 'Wiesenwalze',
		'IMPLEMENT.TYPE.9_8': 'Mulcher',
		'IMPLEMENTS': 'Anbaugeräte',
		'IMPLEMENTS.ALL': 'Alle Anbaugeräte',
		'IMPLEMENTS.DEACTIVATE.FAILURE': 'Nicht alle ausgewählten Anbaugeräte konnten deaktiviert werden!',
		'IMPLEMENTS.DEACTIVATE.QUESTION': 'Sollen die ausgewählten Anbaugeräte wirklich deaktiviert werden?',
		'IMPLEMENTS.DEACTIVATE.SUCCESS': 'Die ausgewählten Anbaugeräte wurden deaktiviert',
		'IMPLEMENTS.DELETE.FAILURE': 'Es konnten nicht alle ausgewählten Anbaugeräte gelöscht werden!',
		'IMPLEMENTS.DELETE.QUESTION': 'Wollen Sie die ausgewählten Anbaugeräte löschen?',
		'IMPLEMENTS.DELETE.SUCCESS': 'Anbaugeräte/Anhänger gelöscht',
		'IMPLEMENTS.MANAGEMENT': 'Anbaugeräte-/Anhängerverwaltung',
		'IMPLEMENTS.NO': 'Keine Anbaugeräte',
		'IMPLEMENTS.NOT_SELECTED': 'Keine Anbaugeräte ausgewählt',
		'IMPLEMENTS.REACTIVATE.FAILURE': 'Nicht alle ausgewählten Anbaugeräte konnten reaktiviert werden!',
		'IMPLEMENTS.REACTIVATE.QUESTION': 'Sollen die ausgewählten Anbaugeräte wirklich reaktiviert werden?',
		'IMPLEMENTS.REACTIVATE.SUCCESS': 'Die ausgewählten Anbaugeräte wurden reaktiviert',
		'IMPLEMENTS.SELECTED': 'Ausgewählte Anbaugeräte',
		'IMPLEMENT_SCAN_DISABLED': 'Anbaugerät-Beacon Scan deaktivieren',
		'IMPORT': 'Importieren',
		'INACTIVE': 'Inaktiv',
		'INDIVIDUAL_LABELING': 'Individuelle Zustandsbestimmung',
		'INFO': 'Info',
		'INTERPOLATION.MAP': 'Interpolationskarte',
		'INTERPOLATION.MAP.SETTINGS': 'Einstellungen Interpolationskarte',
		'IO_BOX_ACTIVATED': 'IOBox aktivieren',
		'ISOBUS.DDI.1': 'Sollwert Ausbringmenge',
		'ISOBUS.DDI.10': 'Maximale Ausbringmenge',
		'ISOBUS.DDI.100': 'Verunreinigung Erntegut',
		'ISOBUS.DDI.101': 'Sollwert Ballenbreite',
		'ISOBUS.DDI.102': 'Istwert Ballenbreite',
		'ISOBUS.DDI.103': 'Voreingestellte Ballenbreite',
		'ISOBUS.DDI.104': 'Minimale Ballenbreite',
		'ISOBUS.DDI.105': 'Maximale Ballenbreite',
		'ISOBUS.DDI.106': 'Sollwert Ballenhöhe',
		'ISOBUS.DDI.107': 'Istwert Ballenhöhe',
		'ISOBUS.DDI.108': 'Voreingestellte Ballenhöhe',
		'ISOBUS.DDI.109': 'Minimale Ballenhöhe',
		'ISOBUS.DDI.11': 'Sollwert Ausbringmenge',
		'ISOBUS.DDI.110': 'Maximale Ballenhöhe',
		'ISOBUS.DDI.111': 'Sollwert Ballenlänge',
		'ISOBUS.DDI.112': 'Tatsächliche Ballenlänge',
		'ISOBUS.DDI.113': 'Voreingestellte Ballenlänge',
		'ISOBUS.DDI.114': 'Minimale Ballenlänge',
		'ISOBUS.DDI.115': 'Maximale Ballenlänge',
		'ISOBUS.DDI.116': 'Bearbeitete Fläche Gesamt',
		'ISOBUS.DDI.117': 'Strecke in Arbeitsstellung',
		'ISOBUS.DDI.118': 'Strecke nicht in Arbeitsstellung',
		'ISOBUS.DDI.119': 'Zeit in Arbeitsstellung',
		'ISOBUS.DDI.12': 'Istwert Ausbringmenge',
		'ISOBUS.DDI.120': 'Zeit nicht in Arbeitsstellung',
		'ISOBUS.DDI.121': 'Dichte Erntegut',
		'ISOBUS.DDI.122': 'Dichte Erntegut',
		'ISOBUS.DDI.123': 'Dichte Erntegut',
		'ISOBUS.DDI.124': 'Faktor Hydraulikventil Ausgang',
		'ISOBUS.DDI.125': 'Faktor Hydraulikventil Eingang',
		'ISOBUS.DDI.126': 'Steigung Hydraulikventil Ausgang öffnen',
		'ISOBUS.DDI.127': 'Steigung Hydraulikventil Ausgang schließen',
		'ISOBUS.DDI.128': 'Steigung Hydraulikventil Eingang öffnen',
		'ISOBUS.DDI.129': 'Steigung Hydraulikventil Eingang schließen',
		'ISOBUS.DDI.13': 'Voreingestellte Ausbringmenge',
		'ISOBUS.DDI.130': 'Schwelle Schwimmstellung Hydraulikventil',
		'ISOBUS.DDI.131': 'Hilfsventil Progressivität vergrößern',
		'ISOBUS.DDI.132': 'Hilfsventil Progressivität verkleinern',
		'ISOBUS.DDI.133': 'Hydraulikventil Umkehrmodus',
		'ISOBUS.DDI.134': 'Versatz Gerät X-Richtung',
		'ISOBUS.DDI.135': 'Versatz Gerät Y-Richtung',
		'ISOBUS.DDI.136': 'Versatz Gerät Z-Richtung',
		'ISOBUS.DDI.137': 'Fassungsvermögen Gerät',
		'ISOBUS.DDI.138': 'Fassungsvermögen Gerät',
		'ISOBUS.DDI.139': 'Fassungsvermögen Gerät',
		'ISOBUS.DDI.14': 'Minimale Ausbringmenge',
		'ISOBUS.DDI.140': 'Ausbringmenge',
		'ISOBUS.DDI.141': 'Arbeitsstellung',
		'ISOBUS.DDI.142': 'Zeitverzögerung Sollwert',
		'ISOBUS.DDI.143': 'Zeitverzögerung Istwert',
		'ISOBUS.DDI.144': 'Gierwinkel',
		'ISOBUS.DDI.145': 'Rollwinkel',
		'ISOBUS.DDI.146': 'Nickwinkel',
		'ISOBUS.DDI.147': 'Log-Zäher',
		'ISOBUS.DDI.148': 'Kraftstoffverbrauch Gesamt',
		'ISOBUS.DDI.149': 'Kraftstoffverbrauch',
		'ISOBUS.DDI.15': 'Maximale Ausbringmenge',
		'ISOBUS.DDI.150': 'Kraftstoffverbrauch',
		'ISOBUS.DDI.151': 'Flächenleistung',
		'ISOBUS.DDI.153': 'NDVI Index',
		'ISOBUS.DDI.154': 'Gerät Länge',
		'ISOBUS.DDI.155': 'Gerät Breite',
		'ISOBUS.DDI.156': 'Gerät Höhe',
		'ISOBUS.DDI.157': 'Anhängung',
		'ISOBUS.DDI.158': 'Status teilflächenspezifische Ausbringung',
		'ISOBUS.DDI.159': 'Anzahl der Untereinheiten pro Abschnitt',
		'ISOBUS.DDI.16': 'Sollwert Pflanzweite',
		'ISOBUS.DDI.160': 'Status automatische Teilbreitenschaltung',
		'ISOBUS.DDI.161': 'Arbeitsstellung Einheiten 1-16',
		'ISOBUS.DDI.162': 'Arbeitsstellung Einheiten 17-32',
		'ISOBUS.DDI.163': 'Arbeitsstellung Einheiten 33-48',
		'ISOBUS.DDI.164': 'Arbeitsstellung Einheiten 49-64',
		'ISOBUS.DDI.165': 'Arbeitsstellung Einheiten 65-80',
		'ISOBUS.DDI.166': 'Arbeitsstellung Einheiten 81-96',
		'ISOBUS.DDI.167': 'Arbeitsstellung Einheiten 97-112',
		'ISOBUS.DDI.168': 'Arbeitsstellung Einheiten 113-128',
		'ISOBUS.DDI.169': 'Arbeitsstellung Einheiten 129-144',
		'ISOBUS.DDI.17': 'Istwert Pflanzweite',
		'ISOBUS.DDI.170': 'Arbeitsstellung Einheiten 145-160',
		'ISOBUS.DDI.171': 'Arbeitsstellung Einheiten 161-176',
		'ISOBUS.DDI.172': 'Arbeitsstellung Einheiten 177-192',
		'ISOBUS.DDI.173': 'Arbeitsstellung Einheiten 193-208',
		'ISOBUS.DDI.174': 'Arbeitsstellung Einheiten 209-224',
		'ISOBUS.DDI.175': 'Arbeitsstellung Einheiten 225-240',
		'ISOBUS.DDI.176': 'Arbeitsstellung Einheiten 241-256',
		'ISOBUS.DDI.177': 'Istwert Schnittlänge',
		'ISOBUS.DDI.178': 'Elementtyp-Instanz (ETI)',
		'ISOBUS.DDI.179': 'Verfahren',
		'ISOBUS.DDI.18': 'Voreingestellte Pflanzweite',
		'ISOBUS.DDI.180': 'Geräte-Referenzpunkt (DRP)Abstand zum Boden',
		'ISOBUS.DDI.181': 'Ertrag Trockemasse',
		'ISOBUS.DDI.182': 'Ertrag Trockemasse',
		'ISOBUS.DDI.183': 'Ertrag Trockenmasse Gesamt',
		'ISOBUS.DDI.184': 'Feuchte',
		'ISOBUS.DDI.185': 'Ertrag Baumwollsamen',
		'ISOBUS.DDI.186': 'Ertrag Baumwollfasern',
		'ISOBUS.DDI.187': 'Ertrag Baumwollsamen',
		'ISOBUS.DDI.188': 'Ertrag Baumwollfasern',
		'ISOBUS.DDI.189': 'Ertrag Baumwollsamen Gesamt',
		'ISOBUS.DDI.19': 'Minimale Pflanzweite',
		'ISOBUS.DDI.190': 'Ertrag Baumwollfasern Gesamt',
		'ISOBUS.DDI.191': 'Faseranteil',
		'ISOBUS.DDI.192': 'Umgebungstemperatur',
		'ISOBUS.DDI.193': 'Sollwert Ausbringdruck',
		'ISOBUS.DDI.194': 'Istwert Ausbringdruck',
		'ISOBUS.DDI.195': 'Minimaler Ausbringdruck',
		'ISOBUS.DDI.196': 'Maximaler Ausbringdruck',
		'ISOBUS.DDI.197': 'Sollwert Förderdruck',
		'ISOBUS.DDI.198': 'Istwert Förderdruck',
		'ISOBUS.DDI.199': 'Minmaler Förderdruck',
		'ISOBUS.DDI.2': 'Istwert Ausbringmenge',
		'ISOBUS.DDI.20': 'Maximale Pflanzweite',
		'ISOBUS.DDI.200': 'Maximaler Förderdruck',
		'ISOBUS.DDI.201': 'Sollwert Druck Spülsystem',
		'ISOBUS.DDI.202': 'Istwert Druck Spülsystem',
		'ISOBUS.DDI.203': 'Minimaler Druck Spülsystem',
		'ISOBUS.DDI.204': 'Maximaler Druck Spülsystem',
		'ISOBUS.DDI.205': 'Section Control Einschaltzeit',
		'ISOBUS.DDI.206': 'Section Control Abschaltzeit',
		'ISOBUS.DDI.207': 'Windgeschwindigkeit',
		'ISOBUS.DDI.208': 'Windrichtung',
		'ISOBUS.DDI.209': 'Relative Luftfeuchtigkeit',
		'ISOBUS.DDI.21': 'Sollwert Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.210': 'Bedeckungsgrad Himmel',
		'ISOBUS.DDI.211': 'Anzahl Verdichtungshübe letzter Ballen',
		'ISOBUS.DDI.212': 'Durchschnittliche Feuchtigkeit des letzten Ballens',
		'ISOBUS.DDI.213': 'Anzahl Rafferhübe pro Verdichtunghub letzter Ballen',
		'ISOBUS.DDI.214': 'Ballen Gesamt',
		'ISOBUS.DDI.215': 'Betriebsstunden Gesamt',
		'ISOBUS.DDI.216': 'Istwert Pressdruck',
		'ISOBUS.DDI.217': 'Pressdruck letzter Ballen',
		'ISOBUS.DDI.218': 'Sollwert Presskraft',
		'ISOBUS.DDI.219': 'Istwert Presskraft',
		'ISOBUS.DDI.22': 'Istwert Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.220': 'Presskraft letzter Ballen',
		'ISOBUS.DDI.221': 'Menge Konservierungsmittel letzter Ballen',
		'ISOBUS.DDI.222': 'Tag-Nummer letzter Ballen',
		'ISOBUS.DDI.223': 'Masse letzter Ballen',
		'ISOBUS.DDI.224': 'Delta T',
		'ISOBUS.DDI.225': 'Sollwert Arbeitslänge',
		'ISOBUS.DDI.226': 'Istwert Arbeitslänge',
		'ISOBUS.DDI.227': 'Minimale Arbeitslänge',
		'ISOBUS.DDI.228': 'Maximale Arbeitslänge',
		'ISOBUS.DDI.229': 'Istwert Gewicht Netto',
		'ISOBUS.DDI.23': 'Voreingestellte Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.230': 'Status Waage Netto',
		'ISOBUS.DDI.231': 'Sollwert Gewicht Netto',
		'ISOBUS.DDI.232': 'Istwert Gewicht Brutto',
		'ISOBUS.DDI.233': 'Status Waage Brutto',
		'ISOBUS.DDI.234': 'Minimales Gewicht Brutto',
		'ISOBUS.DDI.235': 'Maximales Gewicht Brutto',
		'ISOBUS.DDI.236': 'Betriebsstunden Dreschtrommel',
		'ISOBUS.DDI.237': 'Arbeitsstellung Erntevorsatz',
		'ISOBUS.DDI.238': 'Arbeitsstellung Erntevorsatz (Drehzahl)',
		'ISOBUS.DDI.239': 'Status Ertragsmessung',
		'ISOBUS.DDI.24': 'Minimale Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.240': 'Status Be- / Entladesystem',
		'ISOBUS.DDI.241': 'Temperatur Erntegut',
		'ISOBUS.DDI.242': 'Sollwert Öffnung Untersieb',
		'ISOBUS.DDI.243': 'Istwert Öffnung Untersieb',
		'ISOBUS.DDI.244': 'Minimale Öffnung Untersieb',
		'ISOBUS.DDI.245': 'Maximale Öffnung Untersieb',
		'ISOBUS.DDI.246': 'Sollwert Öffnung Obersieb',
		'ISOBUS.DDI.247': 'Istwert Öffnung Obersieb',
		'ISOBUS.DDI.248': 'Minimale Öffnung Obersieb',
		'ISOBUS.DDI.249': 'Maximale Öffnung Obersieb',
		'ISOBUS.DDI.25': 'Maximale Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.250': 'Sollwert Dreschkorböffnung',
		'ISOBUS.DDI.251': 'Istwert Dreschkorböffnung',
		'ISOBUS.DDI.252': 'Minimaler Dreschkorböffnung',
		'ISOBUS.DDI.253': 'Maximaler Dreschkorböffnung',
		'ISOBUS.DDI.254': 'Sollwert Drehzahl Gebläse',
		'ISOBUS.DDI.255': 'Istwert Drehzahl Gebläse',
		'ISOBUS.DDI.256': 'Minimale Drehzahl Gebläse',
		'ISOBUS.DDI.257': 'Maximale Drehzahl Gebläse',
		'ISOBUS.DDI.258': 'Temperatur Hydrauliköl',
		'ISOBUS.DDI.259': 'Verzögerung Ertragsmessung Ausschalten',
		'ISOBUS.DDI.26': 'Sollwert Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.260': 'Verzögerung Ertragsmessung Einschalten',
		'ISOBUS.DDI.261': 'Durchschnittliche Erntemenge',
		'ISOBUS.DDI.262': 'Durchschnittliche Feuchte',
		'ISOBUS.DDI.263': 'Durchschnittliche Erntemenge',
		'ISOBUS.DDI.264': 'Offset in X-Richtung Aufhängung relativ zum DRP',
		'ISOBUS.DDI.265': 'Restfläche',
		'ISOBUS.DDI.266': 'Ausbringmenge Gesamt',
		'ISOBUS.DDI.267': 'Ausbringmenge Gesamt',
		'ISOBUS.DDI.268': 'Erntemenge Gesamt',
		'ISOBUS.DDI.269': 'Erntemenge Gesamt',
		'ISOBUS.DDI.27': 'Istwert Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.270': 'Erntemenge Gesamt',
		'ISOBUS.DDI.271': 'Bearbeitete Fläche Gesamt',
		'ISOBUS.DDI.272': 'Strecke in Arbeitsstellung',
		'ISOBUS.DDI.273': 'Strecke nicht in Arbeitsstellung',
		'ISOBUS.DDI.274': 'Betriebsstunden in Arbeitsstellung Gesamt',
		'ISOBUS.DDI.275': 'Betriebsstunden nicht in Arbeitsstellung Gesamt',
		'ISOBUS.DDI.276': 'Kraftstoffverbrauch Gesamt',
		'ISOBUS.DDI.277': 'Kraftstoffverbrauch Gesamt',
		'ISOBUS.DDI.278': 'Kraftstoffverbrauch Gesamt',
		'ISOBUS.DDI.279': 'Ertrag Trockenmasse Gesamt',
		'ISOBUS.DDI.28': 'Voreingestellte Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.280': 'Ertrag Baumwollsamen Gesamt',
		'ISOBUS.DDI.281': 'Ertrag Baumwollfasern Gesamt',
		'ISOBUS.DDI.282': 'Betriebsstunden Dreschtrommel',
		'ISOBUS.DDI.283': 'Erntegut Geschnitten',
		'ISOBUS.DDI.284': 'Erntegut Ungeschnitten',
		'ISOBUS.DDI.285': 'Erntegut Geschnitten Gesamt',
		'ISOBUS.DDI.286': 'Erntegut Ungeschnitten Gesamt',
		'ISOBUS.DDI.287': 'Soll-Status Steuerung Ausbringmenge',
		'ISOBUS.DDI.288': 'Ist-Status Steuerung Ausbringmenge',
		'ISOBUS.DDI.289': 'Sollwert Arbeitsstellung',
		'ISOBUS.DDI.29': 'Minimale Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.290': 'Sollwert Arbeitsstellung Einheiten 1-16',
		'ISOBUS.DDI.291': 'Sollwert Arbeitsstellung Einheiten 17-32',
		'ISOBUS.DDI.292': 'Sollwert Arbeitsstellung Einheiten 33-48',
		'ISOBUS.DDI.293': 'Sollwert Arbeitsstellung Einheiten 49-64',
		'ISOBUS.DDI.294': 'Sollwert Arbeitsstellung Einheiten 65-80',
		'ISOBUS.DDI.295': 'Sollwert Arbeitsstellung Einheiten 81-96',
		'ISOBUS.DDI.296': 'Sollwert Arbeitsstellung Einheiten 97-112',
		'ISOBUS.DDI.297': 'Sollwert Arbeitsstellung Einheiten 113-128',
		'ISOBUS.DDI.298': 'Sollwert Arbeitsstellung Einheiten 129-144',
		'ISOBUS.DDI.299': 'Sollwert Arbeitsstellung Einheiten 145-160',
		'ISOBUS.DDI.3': 'Voreingestellte Ausbringmenge',
		'ISOBUS.DDI.30': 'Maximale Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.300': 'Sollwert Arbeitsstellung Einheiten 161-176',
		'ISOBUS.DDI.301': 'Sollwert Arbeitsstellung Einheiten 177-192',
		'ISOBUS.DDI.302': 'Sollwert Arbeitsstellung Einheiten 193-208',
		'ISOBUS.DDI.303': 'Sollwert Arbeitsstellung Einheiten 209-224',
		'ISOBUS.DDI.304': 'Sollwert Arbeitsstellung Einheiten 225-240',
		'ISOBUS.DDI.305': 'Sollwert Arbeitsstellung Einheiten 241-256',
		'ISOBUS.DDI.306': 'Offset Drehpunkt Gerät in X-Richtung relativ zu DRP',
		'ISOBUS.DDI.307': 'Offset Drehpunkt Gerät in Y-Richtung relativ zu DRP',
		'ISOBUS.DDI.308': 'Istwert Ausbringmenge',
		'ISOBUS.DDI.309': 'Minimale Ausbringmenge',
		'ISOBUS.DDI.31': 'Sollwert Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.310': 'Maximale Ausbringmenge',
		'ISOBUS.DDI.311': 'Ertragspotenzial',
		'ISOBUS.DDI.312': 'Minimales Ertragspotenzial',
		'ISOBUS.DDI.313': 'Maximales Ertragspotenzial',
		'ISOBUS.DDI.314': 'Istwert TS-Gehalt Erntegut',
		'ISOBUS.DDI.315': 'Durchschnittlicher TS-Gehalt Erntegut',
		'ISOBUS.DDI.316': 'Kraftstoffverbrauch in Arbeitsstellung Gesamt',
		'ISOBUS.DDI.317': 'Kraftstoffverbrauch nicht in Arbeitsstellung Gesamt',
		'ISOBUS.DDI.318': 'Ad-Blue Verbrauch in Arbeitsstellung Gesamt',
		'ISOBUS.DDI.319': 'Ad-Blue Verbrauch nicht in Arbeitsstellung Gesamt',
		'ISOBUS.DDI.32': 'Istwert Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.320': 'Letztes Gewicht beladen',
		'ISOBUS.DDI.321': 'Letztes Gewicht nicht beladen',
		'ISOBUS.DDI.322': 'Identifikationsnummer Beladung',
		'ISOBUS.DDI.323': 'Identifikationsnummer Entladung',
		'ISOBUS.DDI.324': 'Betriebsstunden Häckseltrommel',
		'ISOBUS.DDI.325': 'Ausbringmenge Gesamt',
		'ISOBUS.DDI.326': 'Sollwert Drehzahl Erntevorsatz',
		'ISOBUS.DDI.327': 'Istwert Drehzahl Erntevorsatz',
		'ISOBUS.DDI.328': 'Minimale Drehzahl Erntevorsatz',
		'ISOBUS.DDI.329': 'Maximale Drehzahl Erntevorsatz',
		'ISOBUS.DDI.33': 'Voreingestellte Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.330': 'Sollwert Trommeldrehzahl',
		'ISOBUS.DDI.331': 'Istwert Trommeldrehzahl',
		'ISOBUS.DDI.332': 'Minimale Trommeldrehzahl',
		'ISOBUS.DDI.333': 'Maximale Trommeldrehzahl',
		'ISOBUS.DDI.334': 'Betriebsstunden seit letztem Schärfen',
		'ISOBUS.DDI.335': 'Betriebsstunden Frontzapfwelle',
		'ISOBUS.DDI.336': 'Betriebsstunden Heckzapfwelle',
		'ISOBUS.DDI.337': 'Betriebsstunden Frontzapfwelle Gesamt',
		'ISOBUS.DDI.338': 'Betriebsstunden Heckzapfwelle Gesamt',
		'ISOBUS.DDI.339': 'Zeit Beladen',
		'ISOBUS.DDI.34': 'Minimale Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.340': 'Zeit Entladen',
		'ISOBUS.DDI.341': 'Sollwert Öffnung Corn-Cracker',
		'ISOBUS.DDI.342': 'Istwert Öffnung Corn-Cracker',
		'ISOBUS.DDI.343': 'Minimale Öffnung Corn-Cracker',
		'ISOBUS.DDI.344': 'Maximale Öffnung Corn-Cracker',
		'ISOBUS.DDI.345': 'Sollwert Schwadbreite',
		'ISOBUS.DDI.346': 'Istwert Schwadbreite',
		'ISOBUS.DDI.347': 'Minimale Schwadbreite',
		'ISOBUS.DDI.348': 'Maximale Schwadbreite',
		'ISOBUS.DDI.349': 'Abdriftklasse Düse',
		'ISOBUS.DDI.35': 'Maximale Applikationsmenge pro Ausbringmenge',
		'ISOBUS.DDI.350': 'Funktion oder Verfahren',
		'ISOBUS.DDI.351': 'Ausbringemenge Gesamt',
		'ISOBUS.DDI.352': 'Ausbringemenge Gesamt',
		'ISOBUS.DDI.353': 'Ausbringemenge Stickstoff',
		'ISOBUS.DDI.354': 'Ausbringemenge Ammonium',
		'ISOBUS.DDI.355': 'Ausbringemenge Phosphor',
		'ISOBUS.DDI.356': 'Ausbringemenge Kalium',
		'ISOBUS.DDI.357': 'Ausbringemenge Trockenmasse',
		'ISOBUS.DDI.358': 'Erntemenge Trockenmasse',
		'ISOBUS.DDI.359': 'Erntemenge Trockenmasse',
		'ISOBUS.DDI.36': 'Sollwert Ausbringmenge',
		'ISOBUS.DDI.360': 'Größe letzter Ballen',
		'ISOBUS.DDI.361': 'Dichte letzter Ballen',
		'ISOBUS.DDI.362': 'Ballenlänge Gesamt',
		'ISOBUS.DDI.363': 'Trockenmasse letzter Ballen',
		'ISOBUS.DDI.364': 'Größe Teilballen',
		'ISOBUS.DDI.365': 'Sollwert Schardruck',
		'ISOBUS.DDI.366': 'Istwert Schwardruck',
		'ISOBUS.DDI.367': 'Status Übersteuerung Arbeitsstellung Einheiten 1-16',
		'ISOBUS.DDI.368': 'Status Übersteuerung Arbeitsstellung Einheiten 17-32',
		'ISOBUS.DDI.369': 'Status Übersteuerung Arbeitsstellung Einheiten 33-48',
		'ISOBUS.DDI.37': 'Istwert Ausbringmenge',
		'ISOBUS.DDI.370': 'Status Übersteuerung Arbeitsstellung Einheiten 49-64',
		'ISOBUS.DDI.371': 'Status Übersteuerung Arbeitsstellung Einheiten 65-80',
		'ISOBUS.DDI.372': 'Status Übersteuerung Arbeitsstellung Einheiten 81-96',
		'ISOBUS.DDI.373': 'Status Übersteuerung Arbeitsstellung Einheiten 97-112',
		'ISOBUS.DDI.374': 'Status Übersteuerung Arbeitsstellung Einheiten 113-128',
		'ISOBUS.DDI.375': 'Status Übersteuerung Arbeitsstellung Einheiten 129-144',
		'ISOBUS.DDI.376': 'Status Übersteuerung Arbeitsstellung Einheiten 145-160',
		'ISOBUS.DDI.377': 'Status Übersteuerung Arbeitsstellung Einheiten 161-176',
		'ISOBUS.DDI.378': 'Status Übersteuerung Arbeitsstellung Einheiten 177-192',
		'ISOBUS.DDI.379': 'Status Übersteuerung Arbeitsstellung Einheiten 193-208',
		'ISOBUS.DDI.38': 'Voreingestellte Ausbringmenge',
		'ISOBUS.DDI.380': 'Status Übersteuerung Arbeitsstellung Einheiten 209-224',
		'ISOBUS.DDI.381': 'Status Übersteuerung Arbeitsstellung Einheiten 225-240',
		'ISOBUS.DDI.382': 'Status Übersteuerung Arbeitsstellung Einheiten 241-256',
		'ISOBUS.DDI.383': 'Scheinbare Windrichtung',
		'ISOBUS.DDI.384': 'Scheinbare Windgeschwindigkeit',
		'ISOBUS.DDI.385': 'Luftdruck MSL',
		'ISOBUS.DDI.386': 'Istwert Luftdruck',
		'ISOBUS.DDI.387': 'Umdrehungen Gesamt',
		'ISOBUS.DDI.388': 'Umdrehungen Gesamt',
		'ISOBUS.DDI.389': 'Sollwert Drehzahl',
		'ISOBUS.DDI.39': 'Minimale Ausbringmenge',
		'ISOBUS.DDI.390': 'Istwert Drehzahl',
		'ISOBUS.DDI.391': 'Voreingestellte Drehzahl',
		'ISOBUS.DDI.392': 'Minimale Drehzahl',
		'ISOBUS.DDI.393': 'Maximale Drehzahl',
		'ISOBUS.DDI.394': 'Füllstand Kraftstofftank',
		'ISOBUS.DDI.395': 'Füllstand Ad-Blue Tank',
		'ISOBUS.DDI.396': 'Sollwert Geschwindigkeit',
		'ISOBUS.DDI.397': 'Istwert Geschwindigkeit',
		'ISOBUS.DDI.398': 'Minimale Geschwindigkeit',
		'ISOBUS.DDI.399': 'Maximale Geschwindigkeit',
		'ISOBUS.DDI.4': 'Minimale Ausbringmenge',
		'ISOBUS.DDI.40': 'Maximale Ausbringmenge',
		'ISOBUS.DDI.400': 'Typ Signal Fahrgeschwindigkiet',
		'ISOBUS.DDI.401': 'Ausbringmenge Stickstoff',
		'ISOBUS.DDI.402': 'Ausbringmenge Ammonium',
		'ISOBUS.DDI.403': 'Ausbringmenge Phosphor',
		'ISOBUS.DDI.404': 'Ausbringmenge Kalium',
		'ISOBUS.DDI.405': 'Ausbringmenge Trockenmasse',
		'ISOBUS.DDI.406': 'Istwert Proteingehalt',
		'ISOBUS.DDI.407': 'Durchschnittlicher Proteingehalt',
		'ISOBUS.DDI.408': 'Durchschnittliche Verunreinigung Erntegut',
		'ISOBUS.DDI.409': 'Ad-Blue Verbrauch',
		'ISOBUS.DDI.41': 'Sollwert Ausbringmenge',
		'ISOBUS.DDI.410': 'Ad-Blue Verbrauch',
		'ISOBUS.DDI.411': 'Ad-Blue Verbrauch',
		'ISOBUS.DDI.412': 'Ad-Blue Verbrauch Gesamt',
		'ISOBUS.DDI.413': 'Ad-Blue Verbrauch Gesamt',
		'ISOBUS.DDI.414': 'Ad-Blue Verbrauch Gesamt',
		'ISOBUS.DDI.415': 'Istwert Einzelablage Saatgut',
		'ISOBUS.DDI.416': 'Durchschnittliche Einzelablage Saatgut',
		'ISOBUS.DDI.417': 'Istwert Fehlstellen Saatgut',
		'ISOBUS.DDI.418': 'Durchschnittswert Fehlstellen Saatgut',
		'ISOBUS.DDI.419': 'Istwert Doppelstellen Saatgut',
		'ISOBUS.DDI.42': 'Istwert Ausbringmenge',
		'ISOBUS.DDI.420': 'Durchschnittswert Doppelstellen Saatgut',
		'ISOBUS.DDI.421': 'Standardabweichung Saatabstand von Sollwert',
		'ISOBUS.DDI.422': 'Durchschnittliche Standardabweichung Saatabstand von Sollwert',
		'ISOBUS.DDI.423': 'Aktueller Variantionskoeffizient Saatabstand',
		'ISOBUS.DDI.424': 'Durchschnittlicher Variantionskoeffizient Saatabstand',
		'ISOBUS.DDI.425': 'Sollwert Maximal zulässige Abweichung Saatabstand',
		'ISOBUS.DDI.426': 'Sollwert Schardruck',
		'ISOBUS.DDI.427': 'Istwert Schardruck',
		'ISOBUS.DDI.428': 'Menge Beladen',
		'ISOBUS.DDI.429': 'Menge Entladen',
		'ISOBUS.DDI.43': 'Voreingestellte Ausbringmenge',
		'ISOBUS.DDI.430': 'Menge Beladen Gesamt',
		'ISOBUS.DDI.431': 'Menge Entladen Gesamt',
		'ISOBUS.DDI.432': 'Sollwert Ausbringmenge Stickstoff',
		'ISOBUS.DDI.433': 'Istwert Ausbringmenge Stickstoff',
		'ISOBUS.DDI.434': 'Minimale Ausbringmenge Stickstoff',
		'ISOBUS.DDI.435': 'Maximale Ausbringmenge Stickstoff',
		'ISOBUS.DDI.436': 'Sollwert Ausbringmenge Ammonium',
		'ISOBUS.DDI.437': 'Istwert Ausbringmenge Ammonium',
		'ISOBUS.DDI.438': 'Minimale Ausbringmenge Ammonium',
		'ISOBUS.DDI.439': 'Maximale Ausbringmenge Ammonium',
		'ISOBUS.DDI.44': 'Minimale Ausbringmenge',
		'ISOBUS.DDI.440': 'Sollwert Ausbringmenge Phosphor',
		'ISOBUS.DDI.441': 'Istwert Ausbringmenge Phosphor',
		'ISOBUS.DDI.442': 'Minimale Ausbringmenge Phosphor',
		'ISOBUS.DDI.443': 'Maximale Ausbringmenge Phosphor',
		'ISOBUS.DDI.444': 'Sollwert Ausbringmenge Kalium',
		'ISOBUS.DDI.445': 'Istwert Ausbringmenge Kalium',
		'ISOBUS.DDI.446': 'Minimale Ausbringmenge Kalium',
		'ISOBUS.DDI.447': 'Maximale Ausbringmenge Kalium',
		'ISOBUS.DDI.448': 'Sollwert Ausbringmenge Trockenmasse',
		'ISOBUS.DDI.449': 'Istwert Ausbringmenge Trockenmasse',
		'ISOBUS.DDI.45': 'Maximale Ausbringmenge',
		'ISOBUS.DDI.450': 'Minimale Ausbringmenge Trockenmasse',
		'ISOBUS.DDI.451': 'Maximale Ausbringmenge Trockenmasse',
		'ISOBUS.DDI.452': 'Menge Beladen',
		'ISOBUS.DDI.453': 'Menge Entladen',
		'ISOBUS.DDI.454': 'Menge Beladen Gesamt',
		'ISOBUS.DDI.455': 'Menge Entladen Gesamt',
		'ISOBUS.DDI.456': 'Zuletzt geladene Menge',
		'ISOBUS.DDI.457': 'Zuletzt entladene Menge',
		'ISOBUS.DDI.458': 'Menge Beladen',
		'ISOBUS.DDI.459': 'Menge Entladen',
		'ISOBUS.DDI.46': 'Sollwert Ausbringmenge',
		'ISOBUS.DDI.460': 'Menge Beladen Gesamt',
		'ISOBUS.DDI.461': 'Menge Entladen Gesamt',
		'ISOBUS.DDI.462': 'Zuletzt geladene Menge',
		'ISOBUS.DDI.463': 'Zuletzt entladene Menge',
		'ISOBUS.DDI.464': 'Transport-Zähler',
		'ISOBUS.DDI.465': 'Füll-Zyklen Gesamt',
		'ISOBUS.DDI.466': 'Winkel Anhängung',
		'ISOBUS.DDI.467': 'Füllstand',
		'ISOBUS.DDI.468': 'Bodenzustand Schnee / Frost',
		'ISOBUS.DDI.469': 'Geschätzter Bodenwassergehalt',
		'ISOBUS.DDI.47': 'Istwert Ausbringmenge',
		'ISOBUS.DDI.470': 'Bodenverdichtung',
		'ISOBUS.DDI.472': 'Sollwert Schnittlänge',
		'ISOBUS.DDI.473': 'Minimale Schnittlänge',
		'ISOBUS.DDI.474': 'Maximale Schnittlänge',
		'ISOBUS.DDI.475': 'Sollwert Pressdruck',
		'ISOBUS.DDI.476': 'Minimaler Pressdruck',
		'ISOBUS.DDI.477': 'Maximaler Pressdruck',
		'ISOBUS.DDI.478': 'Sollwert Größe Teilballen',
		'ISOBUS.DDI.479': 'Minimale Größe Teilballen',
		'ISOBUS.DDI.48': 'Voreingestellte Ausbringmenge',
		'ISOBUS.DDI.480': 'Maximale Größe Teilballen',
		'ISOBUS.DDI.481': 'Sollwert Anzahl Teilballen',
		'ISOBUS.DDI.482': 'Letzter Ballen Anzahl Teilballen',
		'ISOBUS.DDI.483': 'Sollwert Motordrehzahl',
		'ISOBUS.DDI.484': 'Istwert Motordrehzahl',
		'ISOBUS.DDI.485': 'Minimale Motordrehzahl',
		'ISOBUS.DDI.486': 'Maximale Motordrehzahl',
		'ISOBUS.DDI.488': 'Füllstand Ad-Blue Tank',
		'ISOBUS.DDI.489': 'Volumen Ad-Blue Tank',
		'ISOBUS.DDI.49': 'Minimale Ausbringmenge',
		'ISOBUS.DDI.490': 'Volumen Kraftstofftank',
		'ISOBUS.DDI.491': 'Füllstand Kraftstofftank',
		'ISOBUS.DDI.492': 'Betriebsstunden Motor',
		'ISOBUS.DDI.493': 'Betriebsstunden Motor Gesamt',
		'ISOBUS.DDI.494': 'Partner-ID des letzten Ereignisses (Byte 1-4)',
		'ISOBUS.DDI.495': 'Partner-ID des letzten Ereignisses (Byte 5-8)',
		'ISOBUS.DDI.496': 'Partner-ID des letzten Ereignisses (Byte 9-12)',
		'ISOBUS.DDI.497': 'Partner-ID des letzten Ereignisses (Byte 13-16)',
		'ISOBUS.DDI.498': 'Partner-ID des letzten Ereignisses Typ',
		'ISOBUS.DDI.499': 'Partner-ID des letzten Ereignisses Manufacturer ID',
		'ISOBUS.DDI.5': 'Maximale Ausbringmenge',
		'ISOBUS.DDI.50': 'Maximale Ausbringmenge',
		'ISOBUS.DDI.500': 'Partner-ID des letzten Ereignisses Device Class',
		'ISOBUS.DDI.501': 'Sollwert Motordrehmoment',
		'ISOBUS.DDI.502': 'Istwert Motordrehmoment',
		'ISOBUS.DDI.503': 'Minimales Motordrehmoment',
		'ISOBUS.DDI.504': 'Maximales Motordrehmoment',
		'ISOBUS.DDI.505': 'Funktion Fahrgassenschaltung',
		'ISOBUS.DDI.506': 'Sollwert Fahrgassenschaltung',
		'ISOBUS.DDI.507': 'Laufende Nummer der Fahrgasse',
		'ISOBUS.DDI.508': 'Eindeutige A-B Linien ID',
		'ISOBUS.DDI.509': 'Aktuelle Spur',
		'ISOBUS.DDI.51': 'Sollwert Bodenbearbeitungstiefe',
		'ISOBUS.DDI.510': 'Nummer Spur Rechts',
		'ISOBUS.DDI.511': 'Nummer Spur Links',
		'ISOBUS.DDI.512': 'Abstand Spurlinien',
		'ISOBUS.DDI.513': 'Abweichung DRP zu Spurlinie',
		'ISOBUS.DDI.514': 'GNSS-Qualität',
		'ISOBUS.DDI.515': 'Status Fahrgassenschaltung',
		'ISOBUS.DDI.516': 'Fahrgassen-Überdosierung',
		'ISOBUS.DDI.517': 'Sollwert Arbeitsstellung Fahrgasse 1-16',
		'ISOBUS.DDI.518': 'Istwert Arbeitsstellung Fahrgasse  1-16',
		'ISOBUS.DDI.519': 'Anzahl Ballen Gesamt',
		'ISOBUS.DDI.52': 'Istwert Bodenbearbeitungstiefe',
		'ISOBUS.DDI.520': 'Istwert Höhe Abdeckung',
		'ISOBUS.DDI.521': 'Typ GNSS Empfänger',
		'ISOBUS.DDI.522': 'Anzahl gebundener Ballen',
		'ISOBUS.DDI.523': 'Anzahl gewickelter Ballen',
		'ISOBUS.DDI.524': 'Anzahl gebundener Ballen Gesamt',
		'ISOBUS.DDI.525': 'Anzahl gewickelter Ballen Gesamt',
		'ISOBUS.DDI.526': 'Istwert Kühlmitteltemperatur',
		'ISOBUS.DDI.528': 'Durchsatz letzter Ballen',
		'ISOBUS.DDI.529': 'Sollwert Anstellwinkel Scheiben',
		'ISOBUS.DDI.53': 'Voreingestellte Bodenbearbeitungstiefe',
		'ISOBUS.DDI.530': 'Istwert Anstellwinkel Scheiben',
		'ISOBUS.DDI.531': 'Istwert angewendetes Konservierungsmittel',
		'ISOBUS.DDI.532': 'Sollwert angewendetes Konservierungsmittel',
		'ISOBUS.DDI.533': 'Voreingestellung angewendetes Konservierungsmittel',
		'ISOBUS.DDI.534': 'Minimum angewendetes Konservierungsmittel',
		'ISOBUS.DDI.535': 'Maximum angewendetes Konservierungsmittel',
		'ISOBUS.DDI.536': 'Menge Konservierungsmittel',
		'ISOBUS.DDI.537': 'Menge Konservierungsmittel Gesamt',
		'ISOBUS.DDI.538': 'Durchschnitt angewendetes Konservierungsmittel',
		'ISOBUS.DDI.539': 'Volumen Tank Konservierungsmittel',
		'ISOBUS.DDI.54': 'Minimale Bodenbearbeitungstiefe',
		'ISOBUS.DDI.540': 'Füllstand Tank Konservierungsmittel',
		'ISOBUS.DDI.541': 'Istwert Drehzahl Zapfwelle',
		'ISOBUS.DDI.542': 'Sollwert Drehzahl Zapfwelle',
		'ISOBUS.DDI.543': 'Voreinstellung Drehzahl Zapfwelle',
		'ISOBUS.DDI.544': 'Minimale Drehzahl Zapfwelle',
		'ISOBUS.DDI.545': 'Maximale Drehzahl Zapfwelle',
		'ISOBUS.DDI.546': 'Trommelstunden Gesamt',
		'ISOBUS.DDI.547': 'Sollwert Presskraft',
		'ISOBUS.DDI.548': 'Istwert Presskraft',
		'ISOBUS.DDI.549': 'Durchschnittliche Presskraft letzter Ballen',
		'ISOBUS.DDI.55': 'Maximale Bodenbearbeitungstiefe',
		'ISOBUS.DDI.550': 'Bodenbedeckung',
		'ISOBUS.DDI.551': 'Istwert Drehmoment Zapfwelle',
		'ISOBUS.DDI.552': 'Sollwert Drehmoment Zapfwelle',
		'ISOBUS.DDI.553': 'Voreinstellung Drehmoment Zapfwelle',
		'ISOBUS.DDI.554': 'Minimales Drehmoment Zapfwelle',
		'ISOBUS.DDI.555': 'Maximales Drehmoment Zapfwelle',
		'ISOBUS.DDI.556': 'Aktuelle Wetterbedingungen',
		'ISOBUS.DDI.557': 'Sollwert Strom',
		'ISOBUS.DDI.558': 'Istwert Strom',
		'ISOBUS.DDI.559': 'Minimaler Strom',
		'ISOBUS.DDI.56': 'Sollwert Aussaattiefe',
		'ISOBUS.DDI.560': 'Maximaler Strom',
		'ISOBUS.DDI.561': 'Voreingestellung Strom',
		'ISOBUS.DDI.562': 'Sollwert Spannung',
		'ISOBUS.DDI.563': 'Voreinstellung Spannung',
		'ISOBUS.DDI.564': 'Tatsächliche Spannung',
		'ISOBUS.DDI.565': 'Minimale Spannung',
		'ISOBUS.DDI.566': 'Maximale Spannung',
		'ISOBUS.DDI.567': 'Istwert Widerstand',
		'ISOBUS.DDI.568': 'Sollwert Leistung',
		'ISOBUS.DDI.569': 'Istwert Leistung',
		'ISOBUS.DDI.57': 'Istwert Aussaattiefe',
		'ISOBUS.DDI.570': 'Voreinstellung Leistung',
		'ISOBUS.DDI.571': 'Maximale Leistung',
		'ISOBUS.DDI.572': 'Minimale Leistung',
		'ISOBUS.DDI.573': 'Elektrische Energie Gersamt',
		'ISOBUS.DDI.574': 'Sollwert Energiemenge',
		'ISOBUS.DDI.575': 'Istwert Energiemenge',
		'ISOBUS.DDI.576': 'Minimale Energiemenge',
		'ISOBUS.DDI.577': 'Maximale Energiemenge',
		'ISOBUS.DDI.578': 'Sollwert Temperatur',
		'ISOBUS.DDI.579': 'Istwert Temperatur',
		'ISOBUS.DDI.58': 'Voreingestellte Aussaattiefe',
		'ISOBUS.DDI.580': 'Minimale Temperatur',
		'ISOBUS.DDI.581': 'Maximale Temperatur',
		'ISOBUS.DDI.582': 'Voreinstellung Temperatur',
		'ISOBUS.DDI.583': 'Sollwert Frequenz',
		'ISOBUS.DDI.584': 'Istwert Frequenz',
		'ISOBUS.DDI.585': 'Minimale Frequenz',
		'ISOBUS.DDI.586': 'Maximale Frequenz',
		'ISOBUS.DDI.587': 'Vorherige Regenfälle',
		'ISOBUS.DDI.588': 'Sollwert Ausbringmenge',
		'ISOBUS.DDI.589': 'Istwert Ausbringmenge',
		'ISOBUS.DDI.59': 'Minimale Aussaattiefe',
		'ISOBUS.DDI.590': 'Minimale Ausbringmenge',
		'ISOBUS.DDI.591': 'Maximale Ausbringmenge',
		'ISOBUS.DDI.592': 'Voreinstellung Ausbringmenge',
		'ISOBUS.DDI.593': 'Typ Fahrgestell',
		'ISOBUS.DDI.594': 'Typ Lenkung',
		'ISOBUS.DDI.595': 'Maschinenstatus',
		'ISOBUS.DDI.596': 'Status Frachtraumabdeckung',
		'ISOBUS.DDI.597': 'Strecke',
		'ISOBUS.DDI.598': 'Strecke Gesamt',
		'ISOBUS.DDI.599': 'Strecke Feld',
		'ISOBUS.DDI.6': 'Sollwert Ausbringmenge',
		'ISOBUS.DDI.60': 'Maximale Aussaattiefe',
		'ISOBUS.DDI.600': 'Strecke Feld Gesamt',
		'ISOBUS.DDI.601': 'Strecke Straße',
		'ISOBUS.DDI.602': 'Strecke Straße Gesamt',
		'ISOBUS.DDI.603': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 17-32',
		'ISOBUS.DDI.604': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 33-48',
		'ISOBUS.DDI.605': 'Istwert  Status Arbeitsstellung Fahrgasse Einheiten 49-64',
		'ISOBUS.DDI.606': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 65-80',
		'ISOBUS.DDI.607': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 81-96',
		'ISOBUS.DDI.608': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 97-112',
		'ISOBUS.DDI.609': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 113-128',
		'ISOBUS.DDI.61': 'Sollwert Arbeitshöhe',
		'ISOBUS.DDI.610': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 129-144',
		'ISOBUS.DDI.611': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 145-160',
		'ISOBUS.DDI.612': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 161-176',
		'ISOBUS.DDI.613': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 177-192',
		'ISOBUS.DDI.614': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 193-208',
		'ISOBUS.DDI.615': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 209-224',
		'ISOBUS.DDI.616': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 225-240',
		'ISOBUS.DDI.617': 'Istwert Status Arbeitsstellung Fahrgasse Einheiten 241-256',
		'ISOBUS.DDI.618': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 17-32',
		'ISOBUS.DDI.619': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 33-48',
		'ISOBUS.DDI.62': 'Istwert Arbeitshöhe',
		'ISOBUS.DDI.620': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 49-64',
		'ISOBUS.DDI.621': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 65-80',
		'ISOBUS.DDI.622': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 81-96',
		'ISOBUS.DDI.623': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 97-112',
		'ISOBUS.DDI.624': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 113-128',
		'ISOBUS.DDI.625': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 129-144',
		'ISOBUS.DDI.626': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 145-160',
		'ISOBUS.DDI.627': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 161-176',
		'ISOBUS.DDI.628': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 177-192',
		'ISOBUS.DDI.629': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 193-208',
		'ISOBUS.DDI.63': 'Voreingestellte Arbeitshöhe',
		'ISOBUS.DDI.630': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 209-224',
		'ISOBUS.DDI.631': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 225-240',
		'ISOBUS.DDI.632': 'Sollwert Status Arbeitsstellung Fahrgasse Einheiten 241-256',
		'ISOBUS.DDI.634': 'Istvolumen pro Strecke Ausbringungsmenge',
		'ISOBUS.DDI.635': 'Standardvolumen pro Strecke Ausbringungsmenge',
		'ISOBUS.DDI.636': 'Minimales Volumen pro Strecke Ausbringungsmenge',
		'ISOBUS.DDI.637': 'Maximale Volumen pro Strecke Ausbringungsmenge',
		'ISOBUS.DDI.638': 'Sollwert Reifendruck',
		'ISOBUS.DDI.639': 'Istwert Reifendruck',
		'ISOBUS.DDI.64': 'Minimale Arbeitshöhe',
		'ISOBUS.DDI.640': 'Voreingestellter-Reifendruck',
		'ISOBUS.DDI.641': 'Minimaler Reifendruck',
		'ISOBUS.DDI.642': 'Maximaler Reifendruck',
		'ISOBUS.DDI.643': 'Istwert Reifentemperatur',
		'ISOBUS.DDI.65': 'Maximale Arbeitshöhe',
		'ISOBUS.DDI.66': 'Sollwert Arbeitsbreite',
		'ISOBUS.DDI.67': 'Istwert Arbeitsbreite',
		'ISOBUS.DDI.68': 'Voreingestellte Arbeitsbreite',
		'ISOBUS.DDI.69': 'Minimale Arbeitsbreite',
		'ISOBUS.DDI.7': 'Istwert Ausbringmenge',
		'ISOBUS.DDI.70': 'Maximale Arbeitsbreite',
		'ISOBUS.DDI.71': 'Sollwert Füllstand',
		'ISOBUS.DDI.72': 'Istwert Füllstand',
		'ISOBUS.DDI.73': 'Maximaler Füllstand',
		'ISOBUS.DDI.74': 'Sollwert Füllstand',
		'ISOBUS.DDI.75': 'Istwert Füllstand',
		'ISOBUS.DDI.76': 'Maximaler Füllstand',
		'ISOBUS.DDI.77': 'Sollwert Füllstand',
		'ISOBUS.DDI.78': 'Istwert Füllstand',
		'ISOBUS.DDI.79': 'Maximaler Füllstand',
		'ISOBUS.DDI.8': 'Voreingestellte Ausbringmenge',
		'ISOBUS.DDI.80': 'Ausbringmenge Gesamt',
		'ISOBUS.DDI.81': 'Ausbringmenge Gesamt',
		'ISOBUS.DDI.82': 'Ausbringmenge Gesamt',
		'ISOBUS.DDI.83': 'Erntemenge',
		'ISOBUS.DDI.84': 'Erntemenge',
		'ISOBUS.DDI.85': 'Erntemenge',
		'ISOBUS.DDI.86': 'Erntemenge',
		'ISOBUS.DDI.87': 'Erntemenge',
		'ISOBUS.DDI.88': 'Erntemenge',
		'ISOBUS.DDI.89': 'Erntemenge Gesamt',
		'ISOBUS.DDI.9': 'Minimale Ausbringmenge',
		'ISOBUS.DDI.90': 'Erntemenge Gesamt',
		'ISOBUS.DDI.91': 'Erntemenge Gesamt',
		'ISOBUS.DDI.92': 'Ernteverlust',
		'ISOBUS.DDI.93': 'Ernteverlust',
		'ISOBUS.DDI.94': 'Ernteverlust',
		'ISOBUS.DDI.95': 'Ernteverlust',
		'ISOBUS.DDI.96': 'Ernteverlust',
		'ISOBUS.DDI.97': 'Ernteverlust',
		'ISOBUS.DDI.98': 'Ernteverlust Relativ',
		'ISOBUS.DDI.99': 'Feuchte Erntegut',
		'ISOBUS.DEVICE_CLASS.0': 'NonSpec',
		'ISOBUS.DEVICE_CLASS.1': 'Tractor',
		'ISOBUS.DEVICE_CLASS.10': 'Irrigation',
		'ISOBUS.DEVICE_CLASS.11': 'Transport/Trailer',
		'ISOBUS.DEVICE_CLASS.12': 'Farm Yard Operations',
		'ISOBUS.DEVICE_CLASS.13': 'Powered Auxiliary Devices',
		'ISOBUS.DEVICE_CLASS.14': 'Special Crops',
		'ISOBUS.DEVICE_CLASS.15': 'Earth Work',
		'ISOBUS.DEVICE_CLASS.16': 'Skidder',
		'ISOBUS.DEVICE_CLASS.17': 'Sensor Systems',
		'ISOBUS.DEVICE_CLASS.18': '-',
		'ISOBUS.DEVICE_CLASS.19': 'Timber Harvesters',
		'ISOBUS.DEVICE_CLASS.2': 'Tillage',
		'ISOBUS.DEVICE_CLASS.20': 'Forwarders',
		'ISOBUS.DEVICE_CLASS.21': 'Timber Loaders',
		'ISOBUS.DEVICE_CLASS.22': 'Timber Processing Machines',
		'ISOBUS.DEVICE_CLASS.23': 'Mulcher',
		'ISOBUS.DEVICE_CLASS.24': 'Utility Vehicles',
		'ISOBUS.DEVICE_CLASS.25': 'Slurry/Manure Applicators',
		'ISOBUS.DEVICE_CLASS.26': 'Feeders/Mixers',
		'ISOBUS.DEVICE_CLASS.27': 'Weeders',
		'ISOBUS.DEVICE_CLASS.3': 'Secondary Tillage',
		'ISOBUS.DEVICE_CLASS.4': 'Planters/Seeders',
		'ISOBUS.DEVICE_CLASS.5': 'Fertilizers',
		'ISOBUS.DEVICE_CLASS.6': 'Sprayers',
		'ISOBUS.DEVICE_CLASS.7': 'Harvesters',
		'ISOBUS.DEVICE_CLASS.8': 'Root Harvesters',
		'ISOBUS.DEVICE_CLASS.9': 'Forage',
		"ISOBUS.ELEMENT_NUMBER": "Elementnummer",
		'JOB.ARCHIVE.QUESTION': 'Wollen Sie die gewählte Fahrt wirklich archivieren?',
		'JOB.ARCHIVE.SUCCESS': 'Fahrt wird nun archiviert',
		'JOB.CAN_NOT_BE_DISPLAYED_COMPLETELY': 'Diese Fahrt kann aktuell leider nicht vollständig angezeigt werden. Die obigen Informationen sind unter Umständen veraltet und werden neu berechnet.',
		'JOB.CURRENT_STATUS': 'Aktueller Status',
		'JOB.DELETE.QUESTION': 'Wollen Sie die gewählte Aktivität wirklich löschen? Alle Daten der Aktivität werden unwiderruflich entfernt.',
		'JOB.DELETE.SUCCESS': 'Aktivität ist fürs Löschen vorgemerkt',
		'JOB.DETAILS': 'Fahrtdetails',
		'JOB.DRIVER_IMPLEMENT': 'Fahrer und/oder Anbaugerät ändern oder entfernen.',
		'JOB.EDIT': 'Job bearbeiten',
		'JOB.REGENERATE': 'Fahrt neu generieren',
		'JOB.REGENERATE.DRIVER': 'Fahrerdaten aktualisieren',
		'JOB.REGENERATE.FIELDS': 'Felddaten aktualisieren',
		'JOB.REGENERATE.IMPLEMENT': 'Anbaugerätedaten aktualisieren',
		'JOB.REGENERATE.INTRO': 'Wenn zwischenzeitlich Abrechnungsdaten oder Einstellungen von Maschine, Anbaugerät oder Fahrer geändert wurden, können diese zusätzlich aktualisiert werden.',
		'JOB.REGENERATE.LOCATIONS': 'Ortsdaten aktualisieren',
		'JOB.REGENERATE.MACHINE': 'Maschinendaten aktualisieren',
		'JOB.REGENERATE.QUESTION': 'Welche dieser Daten sollen bei der Neuberechnung aktualisiert werden?',
		'JOB.REGENERATE.SUCCESS': 'Fahrt wird nun neu berechnet',
		'JOB.SPLIT': 'Fahrt trennen',
		'JOB.SPLIT.ADD_SPLIT_TIME': 'Trennzeitpunkt hinzufügen',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO': 'Für sekundengenaue Einstellungen lassen sich die Schieberegler auch mit den Pfeiltasten bedienen.',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO2': 'Zeit(en) zum Trennen der Fahrt hinzufügen / löschen.',
		'JOB.SPLIT.NO_CHANGE': 'Fahrt wurde nicht geändert',
		'JOB.SPLIT.NO_SPLITS': 'Keine Trennzeitpunkte gewählt',
		'JOB.UPDATE': 'Fahrt(en) updaten',
		'JOB.WAITING_TIME_UNTIL_READY': 'Je nach Status kann es wenige Minuten dauern bis die Fahrt wieder vollständig angezeigt werden kann.',
		'JOBS': 'Fahrten',
		'JOBS.ALL': 'Alle Jobs',
		'JOBS.ARCHIVE.PARTIAL': 'Nicht alle Fahrten wurden archiviert',
		'JOBS.ARCHIVE.QUESTION': 'Wollen Sie die gewählten Fahrten archivieren?',
		'JOBS.ARCHIVE.SUCCESS': 'Die Fahrten wurde archiviert',
		'JOBS.CREATE_TASK': 'Auftrag erstellen',
		'JOBS.DELETE.QUESTION': 'Wollen Sie die gewählten Aktivitäten wirklich löschen? Alle Daten der Aktivitäten werden unwiderruflich entfernt.',
		'JOBS.DELETE.SUCCESS': 'Aktivitäten ist fürs Löschen vorgemerkt',
		'JOBS.DELETED.FAILURE': 'Nicht alle ausgewählten Fahrt(en) konnten gelöscht werden!',
		'JOBS.EDIT': 'Fahrt(en) bearbeiten',
		'JOBS.EDIT.SUCCESS': 'Fahrt(en) erfolgreich bearbeitet',
		'JOBS.IN_TASK': 'Fahrten in Aufträgen',
		'JOBS.MERGE.SUCCESS': 'Fahrten werden nun zusammengefügt',
		'JOBS.MERGING': 'Zusammenfügen von Fahrten',
		'JOBS.NO': 'Keine Fahrten',
		'JOBS.NOT_SELECTED': 'Keine Fahrten ausgewählt',
		'JOBS.REGENERATE': 'Fahrt(en) neu generieren',
		'JOBS.REGENERATE.SUCCESS': 'Fahrt(en) werden neu berechnet',
		'JOBS.SELECTED': 'Fahrten ausgewählt',
		'JOBS.TASK_CREATED': 'Task erfolgreich erstellt!',
		'JOBS.UPDATE.SUCCESS': 'Fahrt(en) werden aktualisiert',
		'JOBS.WITHOUT_TASK': 'Fahrten ohne Auftrag',
		'JOBS.WITH_TASK': 'Fahrten in Auftrag',
		'KILOMETERS': 'Kilometer',
		'LANGUAGE': 'Sprache',
		'LANGUAGE.ADD': 'Sprache hinzufügen',
		'LANGUAGE.CODE': 'Sprachcode',
		'LANGUAGE.DEFAULT': 'Standartsprache',
		'LASTNAME': 'Nachname',
		'LAST_ONLINE': 'Zuletzt online',
		'LAST_UPDATED': 'Zuletzt bearbeitet',
		'LATITUDE': 'Latitude',
		'LOAD.MORE': 'Mehr laden',
		'LOADS': 'Ladungen',
		'LOCATION': 'Ort',
		'LOCATION.ADD': 'Ort hinzufügen',
		'LOCATION.ADD.SUCCESS': 'Ort erfolgreich hinzugefügt',
		'LOCATION.DEACTIVATE.QUESTION': 'Wollen sie den Ort wirklich deaktivieren?',
		'LOCATION.DEACTIVATE.SUCCESS': 'Ort erfolgreich deaktiviert',
		'LOCATION.DELETE.QUESTION': 'Wollen sie den Ort wirklich löschen?',
		'LOCATION.DELETE.SUCCESS': 'Ort erfolgreich gelöscht',
		'LOCATION.DETAILS': 'Details Ort',
		'LOCATION.DRAW.START': 'Ort jetzt in Karte markieren!',
		'LOCATION.EDIT.SUCCESS': 'Ort erfolgreich angepasst',
		'LOCATIONS': 'Orte',
		'LOCATIONS.ALL': 'Alle Orte',
		'LOCATIONS.DEACTIVATE.FAILURE': 'Nicht alle ausgewählten Orte konnten deaktiviert werden!',
		'LOCATIONS.DEACTIVATE.QUESTION': 'Wollen sie die Orte wirklich deaktivieren?',
		'LOCATIONS.DEACTIVATE.SUCCESS': 'Orte erfolgreich deaktiviert',
		'LOCATIONS.DELETE.FAILURE': 'Einige der Orte konnten nicht gelöscht werden.',
		'LOCATIONS.DELETE.QUESTION': 'Wollen sie die ausgewählten Orte wirklich löschen?',
		'LOCATIONS.DELETE.SUCCESS': 'Orte erfolgreich gelöscht',
		'LOCATIONS.NO': 'Keine Orte',
		'LOCATIONS.NOT_SELECTED': 'Keine Ort ausgewählt',
		'LOCATIONS.REACTIVATE.FAILURE': 'Nicht alle ausgewählten Orte konnten reaktiviert werden!',
		'LOCATIONS.REACTIVATE.QUESTION': 'Sollen die ausgewählten Orte wirklich reaktiviert werden?',
		'LOCATIONS.REACTIVATE.SUCCESS': 'Die ausgewählten Orte wurden reaktiviert',
		'LOCATIONS.SELECTED': 'Ausgewählte Orte',
		'LOG': 'Nachrichtenlog',
		'LOGIN': 'Anmelden',
		'LOGIN.NOT_UNLOCKED_YET': 'Noch nicht freigeschaltet?',
		'LOGIN.NO_ACCOUNT_YET': 'Noch keinen Account?',
		'LOGIN.PASSWORD_FORGOTTEN': 'Passwort vergessen?',
		'LOGIN.REGISTER': 'Registrieren',
		'LOGIN.REMEMBER_PASSWORD': 'Passwort merken',
		'LOGIN.UNLOCK': 'Freischalten',
		'LOG_OUT': 'Abmelden',
		'LONGITUDE': 'Longitude',
		'LOST_PASSWORD.CHANGE_PASSWORD': 'PASSWORT ÄNDERN',
		'LOST_PASSWORD.ENTER_ACTIVATION': 'Bitte geben sie den Aktivierungscode ein, den Sie per Email erhalten haben.',
		'LOST_PASSWORD.ENTER_EMAIL_HERE': 'Bitte geben sie hier ihre E-Mail Adresse ein.',
		'LOST_PASSWORD.ENTER_VALID_EMAIL': 'Bitte geben sie eine gültige E Mail Adresse ein.',
		'MAC': 'MAC',
		'MACHINE': 'Fahrzeug',
		'MACHINE.ADD': 'Fahrzeug hinzufügen',
		'MACHINE.ADD.SUCCESS': 'Fahrzeug erfolgreich hinzugefügt',
		'MACHINE.DELETE.QUESTION': 'Wollen sie das Fahrzeug wirklich entfernen?',
		'MACHINE.DELETE.SUCCESS': 'Fahrzeug gelöscht',
		'MACHINE.DETAILS': 'Details Fahrzeug',
		'MACHINE.EDIT': 'Fahrzeug bearbeiten',
		'MACHINE.EDIT.SUCCESS': 'Fahrzeug erfolgreich bearbeitet',
		'MACHINE.INTERVAL.ADD': 'Maschinen Intervall hinzufügen',
		'MACHINE.LIVE_STATUS': 'Maschinen Live Status',
		'MACHINE.NO': 'Keine Maschine',
		'MACHINE.RELOAD_POSITIONS': 'Fahrspuren nachladen',
		'MACHINE.STATUS': 'Fahrzeugstatus',
		'MACHINES': 'Fahrzeuge',
		'MACHINES.ALL': 'Alle Fahrzeuge',
		'MACHINES.DEACTIVATE.FAILURE': 'Nicht alle ausgewählten Maschinen konnten deaktiviert werden!',
		'MACHINES.DEACTIVATE.QUESTION': 'Sollen die ausgewählten Maschinen wirklich deaktiviert werden?',
		'MACHINES.DEACTIVATE.SUCCESS': 'Die ausgewählten Maschinen wurden deaktiviert',
		'MACHINES.DELETE.FAILURE': 'Nicht alle Fahrzeuge konnten gelöscht werden.',
		'MACHINES.DELETE.QUESTION': 'Wollen Sie die ausgewählten Fahrzeuge löschen?',
		'MACHINES.DELETE.SUCCESS': 'Fahrzeuge gelöscht',
		'MACHINES.MANAGEMENT': 'Fahrzeugverwaltung',
		'MACHINES.NO': 'Keine Maschinen',
    'MACHINES.NO_ADAPTER.WARNING': 'Dem Fahrzeug ist kein Adapter zugewiesen. Ohne Adapter werden keine Daten aufgezeichnet.',
		'MACHINES.NOT_SELECTED': 'Keine Maschinen ausgewählt',
		'MACHINES.NO_LICENSE.WARNING': 'Dem Fahrzeug ist keine Lizenz zugewiesen. Ohne Lizenz werden keine Daten aufgezeichnet.',
		'MACHINES.REACTIVATE.FAILURE': 'Nicht alle ausgewählten Maschinen konnten reaktiviert werden!',
		'MACHINES.REACTIVATE.QUESTION': 'Sollen die ausgewählten Maschinen wirklich reaktiviert werden?',
		'MACHINES.REACTIVATE.SUCCESS': 'Die ausgewählten Maschinen wurden reaktiviert',
		'MACHINES.SELECTED': 'Ausgewählte Fahrzeuge',
		'MACHINE_COMBINATION': 'Fahrzeugkombination',
		'MACHINE_IMPLEMENT': 'Fahrzeug / Anbaugerät',
		'MAC_DEVICES': 'Mit Fahrzeug verbundener Adapter',
		'MAINTENANCE': 'Wartung',
		'MAINTENANCE.AMOUNT': 'Fällig in / am',
		'MAINTENANCE.PERIOD': 'Wartungsintervall',
		'MAKE': 'Marke',
		'MANURE': 'Gülle',
		'MANURE.TYPE': 'Gülletyp',
		'MAP': 'Karte',
		'MAP.SECTION': 'Kartenausschnitt',
		'MAP.SECTION.CHANGE': 'Kartenausschnitt anpassen',
		'MARKER.ADD': 'Markierung hinzufügen',
		'MARKER.EDIT.BORDERS': 'Grenzen bearbeiten',
		'MARKER.ENTRANCE': 'Zufahrt',
		'MARKER.EXIT': 'Ausfahrt',
		'MARKER.INFO': 'Info',
		'MARKER.WARN': 'Warnung',
		'MAX': 'Max',
		'MAX_VALUE': 'Maximaler Wert',
		'MERGE': 'Fahrten zusammenfügen',
		'MESSAGES.NO': 'Keine Nachrichten vorhanden',
		'MILEAGE': 'Kilometerstand',
		'MILEAGE.INVALID': 'Kilometerstand ungültig',
		'MIN': 'Min',
		'MIN_VALUE': 'Minimaler Wert',
		'MOBILE': 'Mobil',
		'MODE.SWITCH': 'Modus wechseln',
		'MODEL': 'Modell',
		'MYPROFILE': 'Mein Profil',
		'MYPROFILE.BASIC_DATA': 'Anmeldedaten',
		'MYPROFILE.BASIC_DATA.EDIT.SUCCESS': 'Ihre Anmeldedaten wurden erfolgreich geändert',
		'NAME': 'Name',
		'NAV.ACTIVITIES': 'Aktivitäten',
		'NAV.ADMIN': 'Administration',
		'NAV.ADMIN.DASHBOARD': 'Dashboard',
		'NAV.ADMIN.INFO_VIEW': 'Admin Info',
		'NAV.ADMIN.JOB_IMPORT_VIEW': 'Job Import',
		'NAV.ADMIN.JOB_VIEW': 'Job View',
		'NAV.ADMIN.USERS': 'Benutzerverwaltung',
		'NAV.CUSTOMERS': 'Kunden',
		'NAV.DASHBOARD': 'Übersicht',
		'NAV.DATA_PREPARATION': 'Datenaufbereitung',
		'NAV.EMPLOYEES': 'Mitarbeiter',
		'NAV.ENTERPRISE': 'Betrieb',
		'NAV.FIELDS': 'Felder',
		'NAV.FILE_TRANSFER': 'Dateitransfer',
		'NAV.HARDWARE': 'Hardware',
		'NAV.HARDWARE_SETUP': 'Hardware Setup',
		'NAV.IMPLEMENTS': 'Anbaugeräte/Anhänger',
		'NAV.LOCATIONS': 'Orte',
		'NAV.MACHINES': 'Fahrzeuge',
		'NAV.MY_SECTION': 'Mein Bereich',
		'NAV.PATH_PLANNINGS': 'Fahrspurplanung',
		'NAV.RETAILER': 'Retailer',
		'NAV.SETTINGS': 'Einstellungen',
		'NAV.SETTINGS.ADAPTER': 'Adapter',
		'NAV.SETTINGS.GENERAL': 'Betrieb',
		'NAV.SETTINGS.PARTNER': 'Partner',
		'NAV.STATISTIC': 'Statistik',
		'NAV.TECH': 'TECH',
		'NAV.TRANSLATION.EDIT': 'Übersetzung anpassen',
		'NAV.TRANSLATION_MANAGEMENT': 'Übersetzungsverwaltung',
		'NETWORK.ACCESS_TECHNOLOGY': 'Technologie',
		'NETWORK.OPERATOR': 'Betreiber',
		'NEXT': 'Nächste',
		'NO': 'Nein',
		'NO:CROP:TYPE': '',
		'NONE': 'Keine',
		'NOTICE': 'Hinweis',
		'NON_PRODUCTIVE_TIME': 'Nebenzeit',
		'NON_PRODUCTIVE_TIMES': 'Nebenzeiten',
		'NON_PRODUCTIVE_TIMES.SEPARATOR': 'Trenner für Nebenzeitenberechnung',
		'NOT_READ': 'konnte nicht gelesen werden.',
		'NO_DATA': 'keine Daten',
		'ONLY_ON': 'Nur auf',
		'OPACITY': 'Deckkraft',
		'OPERATING_HOURS': 'Betriebsstunden',
		'OPERATING_HOURS.INVALID': 'Betriebsstunden ungültig',
		'OPERATION': 'Maßnahme',
		'OPERATION.NOT_SELECTED': 'Keine Maßnahme ausgewählt',
		'OPERATION.SELECT': 'Maßnahme auswählen',
		'OPERATIONS': 'Maßnahmen',
		'OPERATIONS.ARRIVAL': 'Anfahrt',
		'OPERATIONS.CUSTOMER': 'Maßnahmen für Kunde',
		'OPERATIONS.FIELD': 'Maßnahmen auf dem Feld',
		'OPERATIONS.FIELDS': 'Maßnahmen auf den Feldern',
		'OPERATIONS.FIELD_TIME': 'Feldzeit',
		'OPERATIONS.GEOMETRY': 'Geometrie',
		'OPERATIONS.LOCATION': 'Maßnahme auf Ort',
		'OPERATIONS.LOCATIONS': 'Maßnahmen auf Orten',
		'OPERATIONS.NO': 'Keine Maßnahmen',
		'OPERATIONS.PREPARATION': 'Vorbereitung',
		'OVERRIDE.NO': 'Kein Überschreiben',
		'PAGE': 'Seite',
		'PAGE.OF': 'von',
		'PAGINATION.PER_PAGE': 'Pro Seite',
		'PAGINATION.TOTAL': 'gesamt',
		'PAGINATOR.FIRST_PAGE': 'Erste Seite',
		'PAGINATOR.ITEMS_PER_PAGE': 'Elemente pro Seite',
		'PAGINATOR.LAST_PAGE': 'Letzte Seite',
		'PAGINATOR.NEXT_PAGE': 'Nächste Seite',
		'PAGINATOR.OF': 'von',
		'PAGINATOR.PREVIOUS_PAGE': 'Vorherige Seite',
		'PARTNER_CONNECTION': 'Verknüpfung',
		'PARTNER_CONNECTION.DOES_NOT_EXPIRE': 'Läuft nicht ab',
		'PARTNER_CONNECTION.EXPIRES_ON': 'Läuft ab am',
		'PASSWORD': 'Passwort',
		'PASSWORD.CHANGE': 'Passwort ändern',
		'PASSWORD.CHANGE.ACTIVATE': 'Aktuelles Passwort',
		'PASSWORD.CHANGE.SUCCESS': 'Ihr Passwort wurde erfolgreich geändert',
		'PASSWORD.CONFIRM': 'Neues Passwort bestätigen',
		'PASSWORD.LENGTH.REQUIRED': 'Passwort muss mindestens 6 Zeichen haben',
		'PASSWORD.NEW_PASSWORD': 'Neues Passwort',
		'PASSWORD.NO_MATCH': 'Passwortbestätigung stimmt nicht mit Passwort überein',
		'PATH_PLANNING.ADD': 'Spur planen',
		'PATH_PLANNING.ADD.SUCCESS': 'Geplante Spur erfolgreich hinzugefügt',
		'PATH_PLANNING.ANGLE': 'Winkel',
		'PATH_PLANNING.ANGLE.LONGEST_SIDE': 'Längste Seite',
		'PATH_PLANNING.ANGLE.OPTIMAL': 'Optimal',
		'PATH_PLANNING.ANGLE.WORKING': 'Arbeitswinkel',
		'PATH_PLANNING.AREA.COVERED': 'Bedeckte Fläche',
		'PATH_PLANNING.AREA.OVERLAP': 'Überlappte Fläche',
		'PATH_PLANNING.AREA.UNCOVERED': 'Unbedeckte Fläche',
		'PATH_PLANNING.DETAILS': 'Fahrspur',
		'PATH_PLANNING.GENERATE_PATH': 'Spur generieren',
		'PATH_PLANNING.GEOMETRY.CHANGED.QUESTION': 'Die Feldgrenze bzw. Markierungen wurden angepasst. Sollen die geänderten Daten als die aktuelle Feldgrenze gespeichert werden?',
		'PATH_PLANNING.NAME': 'Spur Name',
		'PATH_PLANNING.NAME.EXPLANATION': 'Gitte gib einen Namen für die Spur ein',
		'PATH_PLANNING.NOT_ENOUGH_DATA_EXPECTATION': 'Aktuell liegen zu wenig Daten für diese Maschinenkombination vor. Daher können voraussichtlicher Kraftstoff- bzw. CO2-Verbrauch und die Kosten nicht berechnet werden',
		'PATH_PLANNING.SELECT.FIELD': 'Klicke auf ein Feld in der Liste, um es für die Spurplanung auszuwählen',
		'PATH_PLANNING.SEND_TO_MACHINE': 'Zur Maschine senden',
		'PATH_PLANNING.SETTINGS.CHANGED.QUESTION': 'Die Einstellungen wurden geändert nachdem die aktuell angezeigte Spur erstellt wurde. Diese Einstellungen gehen beim Speichern verloren. Soll fortgefahren werden?',
		'PATH_PLANNING.SUBDIVIDE': 'Feld unterteilen',
		'PATH_PLANNINGS.DEACTIVATE.FAILURE': 'Nicht alle ausgewählten Fahrspuren konnten deaktiviert werden',
		'PATH_PLANNINGS.DEACTIVATE.QUESTION': 'Wollen sie die Fahrspur wirklich deaktivieren?',
		'PATH_PLANNINGS.DEACTIVATE.SUCCESS': 'Die Fahrspuren wurden deaktiviert',
		'PATH_PLANNINGS.DELETE.FAILURE': 'Nicht alle ausgewählten Fahrspuren konnten gelöscht werden',
		'PATH_PLANNINGS.DELETE.QUESTION': 'Wollen sie die Fahrspur wirklich löschen?',
		'PATH_PLANNINGS.DELETE.SUCCESS': 'Die Fahrspuren wurden gelöscht',
		'PATH_PLANNINGS.MANAGEMENT': 'Fahrspurplanung',
		'PATH_PLANNINGS.NOT_SELECTED': 'Keine Fahrspuren ausgewählt',
		'PATH_PLANNINGS.REACTIVATE.FAILURE': 'Nicht alle ausgewählten Fahrspuren konnten reaktiviert werden',
		'PATH_PLANNINGS.REACTIVATE.QUESTION': 'Wollen sie die Fahrspur wirklich reaktivieren?',
		'PATH_PLANNINGS.REACTIVATE.SUCCESS': 'Die Fahrspuren wurden reaktiviert',
		'PATTERN': 'Muster',
		'PATTERN.END_AT_ENTRANCE': 'An Einfahrt enden',
		'PATTERN.START': 'Musterstart/-ende',
		'PATTERN.START_AT_ENTRANCE': 'An Einfahrt starten',
		'PAUSE': 'Pause',
		'PERFORMANCE.AVERAGE': 'Durchschnittsleistung',
		'PERFORMANCE.AVERAGE.EXPLAINATION': 'Bei diesem Wert werden alle Arbeitszustände berücksichtigt, inkl. Vorbereitung und Straßenfahrten',
		'PERFORMANCE.AVERAGE.FIELD': 'Durchschnittsleistung (Feld)',
		'PERFORMANCE.AVERAGE.FIELD.EXPLAINATION': 'Dieser Wert bezieht sich auf die Arbeitszustände “Arbeiten“, “Wartezeit Feld” und “Wenden”',
		'PERFORMANCE.TOTAL': 'Gesamtleistung',
		'PHONE': 'Kontakt Telefon',
		'PHONE.INVALID': 'Telefonnummer ungültig',
		'PHONE_MOBILE': 'Telefon (Mobil)',
		'PH_VALUE': 'PH-Wert',
		"PLANT_PROTECTANT": "Pflanzenschutzmittel",
		'PLAY': 'Abspielen',
		"POI": "Markierung",
		"POI.ADD": "Markierung hinzufügen",
		'POSTCODE': 'Postleitzahl',
		'PREVIOUS': 'Vorherige Seite',
		'PROCESS': 'Prozess',
		'PROCESSED': 'Bearbeitet',
		'PROCESSED.FAILURE': 'Fehler während der Verarbeitung',
		'PROCESSED.SUCCESSFULL': 'Verarbeitung erfolgreich',
		'PRODUCT': 'Produkt',
		'PROGRESS': 'Fortschritt',
		'PROJECTION': 'Projektion',
		'RAW_DATA': 'Rohdaten',
		'RECEIVED.AT': 'Erhalten am',
		'REGENERATE': 'Regenerieren',
		'REGENERATE.SELECTED': 'Ausgewählte erneut berechnen',
		'REGISTER': 'REGISTRIEREN',
		'REGISTER.ALREADY_REGISTERED?': 'Sind sie schon registriert?',
		'REGISTER.I_ACCEPT_THE': 'Ich akzeptiere die',
		'RELOAD': 'Neu laden',
		'REMOVE': 'Entfernen',
		'RENEW': 'Erneuern',
		'REOCURRING': 'Wiederkehrend',
		'REPORT': 'Report',
		'RESET': 'Zurücksetzen',
		'RESOLUTION': 'Auflösung',
		'RESTORE.DRIVER': 'Fahrer wiederherstellen',
		'RESTORE.IMPLEMENT': 'Anbaugerät wiederherstellen',
		'ROAD': 'Straße',
		'ROLE': 'Rolle',
		'RUNTIME_H': 'Laufzeit in h',
		'SAFETY_CHECK': 'Sicherheitsprüfung',
		'SATELITE': 'Satellitkarte',
		'SAVE': 'Speichern',
		'SCALE.TYPE': 'Waagentyp',
		'SEARCH': 'Suche',
		'SEASON_YEAR': 'Wirtschaftsjahr',
		'SEASON_YEAR.START': 'Start Wirtschaftsjahr',
		'SELECT.ALL': 'Alle Auswählen',
		'SELECT.CLEAR': 'Auswahl aufheben',
		'SELECT.FIELD': 'Feld auswählen',
		'SENSORDATA': 'Sensordaten',
		'SENSORDATA.DESCRIPTION': 'Darstellung der Sensordaten in Graph',
		'SENSORDATA.SELECT_SENSOR': 'Sensor auswählen',
		'SENSORDATA.SHOW_WORKSTATE_COLORS': 'Zustandsfarben anzeigen',
		'SENSOR_PARAMETER': 'Sensorwert',
		'SENSOR_PARAMETER.ADD': 'Sensorwert hinzufügen',
		'SENSOR_PARAMETER.DEFINE_FOR_IMPLEMENT': 'Individuellen Sensorwert für das ausgewählte Anbaugerät definieren.',
		'SENSOR_PARAMETER.DEFINE_INDIVIDUAL_PARAM': 'Individuellen Sensorwert definieren.',
		'SENSOR_PARAMETER.INDIVIDUAL_SENSOR_PARAM': 'Individueller Sensorwert',
		'SENSOR_PARAMETER.NOT_REMOVABLE_USED_IN_OTHER_PARAMETER': 'Sensor Parameter wird in einer anderen Parameter Konfiguration verwendet',
		'SENSOR_PARAMETERS': 'Sensorwerte',
		'SENSOR_PARAMETERS.NO': 'Keine Sensorwerte',
		'SERIAL': 'Seriennummer',
		'SETTINGS': 'Einstellungen',
		'SETTINGS.ADDITIONAL': 'Weitere Einstellungen',
		'SETTINGS.ADVANCED': 'Erweiterte Einstellungen',
		'SETTINGS.AGRIROUTER_CAN_BE_CONNECTED': 'Dein agrirouter Konto kann mit exatrek verbunden werden um Daten zu teilen.',
		'SETTINGS.AGRIROUTER_CONNECTED_AND_READY': 'agrirouter ist verbunden und bereit. Die Verbindung ist gültig bis',
		'SETTINGS.CONNECTION_TO_PARTNERS': 'Verbindung zu Partnern von exatrek',
		'SETTINGS.FARMNET_FIELD_SYNC': 'Felder von 365FarmNet zu exatrek synchronisieren',
		'SETTINGS.FARMNET_IMPLEMENT_SYNC': 'Anbaugeräte von exatrek zu 365FarmNet synchronisieren',
		'SETTINGS.FARMNET_MACHINE_SYNC': 'Maschinen von exatrek zu 365FarmNet synchronisieren',
		'SETTINGS.GO_TO_FARMNET': 'GEHE ZU 365 FARMNET',
		'SETTINGS.ONLY_FARMNET_WEBAPP': 'Die Synchronisierfunktionen zu und von 365FarmNet können nur direkt aus der 365FarmNet Webapp genutzt werden.',
		'SHOW': 'Anzeigen',
		'SHOW_DIRECTION': 'Richtung anzeigen',
		'SHOW_EVENTS': 'Ereignisse anzeigen',
		'SHOW_FIELDS': 'Felder anzeigen',
		'SHOW_LOCATIONS': 'Orte anzeigen',
		'SHOW_OFFLINE_MACHINES': 'Offline Fahrzeuge anzeigen',
		'SHOW_TRACKS': 'Fahrspuren anzeigen',
		'SHOW_TRACKS_': 'Fahrspuren',
		'SNACKBAR.DAYS': 'Tagen',
		'SNACKBAR.LICENSE_EXPIRATION_WARNING': 'Ihre Lizenz läuft ab in',
		'SNACKBAR.MACHINE_ONLINE_WARNING': 'Mindestens eine Maschine war länger nicht online!',
		'SORT_BY': 'Aufteilung nach',
		'SPEED': 'Geschwindigkeit',
		'SPEED.AVERAGE': 'Durchschnittsgeschwindigkeit',
		'SPEED.FASTER': 'Schneller',
		'SPEED.RESET': 'Geschwindigkeit zurücksetzen',
		'SPEED.SIGNAL.OVERRIDE': 'Geschwindigkeitssignal überschreiben',
		'SPEED.SLOWER': 'Langsamer',
		'SPEED.WORKING': 'Arbeitsgeschwindigkeit',
		'SPLIT': 'Aufteilen',
		'START': 'Start',
		'STATISTICS': 'Statistik',
		'STATUS': 'Status',
		'STOP': 'Stop',
		'STORAGE': 'Speicherplatz',
		'STORAGE.USB': 'Speicherplatz USB',
		'STORAGE.USB.USED': 'Speicherverbrauch USB',
		'STORAGE.USED': 'Speicherverbrauch',
		'SYMBOLIZATION': 'Legende',
		'TASK': 'Auftrag',
		'TASK.ADDABLE_JOBS': 'Hinzufügbare Fahrten',
		'TASK.ADD_JOBS': 'Fahrten hinzufügen',
		'TASK.ARCHIVED_JOB_WARNING': 'Dieser Auftrag enthält archivierte Fahrten und wird deswegen nicht vollständig angezeigt!',
		'TASK.DELETE.JOB.FAILURE': 'Ein Auftrag muss mindestens eine Fahrt beinhalten!',
		'TASK.DELETE.JOB.QUESTION': 'Wollen sie diese Fahrt wirklich aus dem Auftrag entfernen?',
		'TASK.DELETE.JOB.SUCCESS': 'Fahrt erfolgreich aus Auftrag entfernt',
		'TASK.DELETE.QUESTION': 'Wollen sie den Auftrag wirklich löschen?',
		'TASK.DELETE.SUCCESS': 'Auftrag erfolgreich gelöscht',
		'TASK.EDIT': 'Auftrag bearbeiten',
		'TASK.EDIT.SUCCESS': 'Auftrag erfolgreich bearbeitet',
		'TASK.EXPORT_DETAILS': 'Export des Auftrags',
		'TASK.JOBS_TO_ADD': 'Hinzugefügte Fahrten',
		'TASK.NEW': 'Neuer Auftrag',
		'TASKS': 'Aufträge',
		'TASKS.NO': 'Keine Aufträge',
		'TASK_CONTROLLER.ACTIVE': 'TaskController (DataLog) aktivieren',
		'TASK_CONTROLLER.COMPAT_ACTIVE': 'TaskController Kompatibilitätsmodus',
		'TAX_ID': 'USt. ID',
		'TC': 'TaskController',
		'TC.ACTIVE': 'TC aktiv',
		'TC.TC_COMP': 'TC comp.',
		'TERMINAL.NO': 'Kein ISOBUS Terminal',
		'TERMINAL.TYPE': 'Terminal Typ',
		'TEST.SUCCESS': 'Erfolgreich ein Test-Konto angefragt - in Kürze erhalten Sie eine eMail',
		'TIME': 'Zeit',
		'TIME.REMAINING': 'Restzeit',
		'TIMEZONE': 'Zeitzone',
		'TITLE': 'Test-Konto anfragen',
		'TOKEN': 'Zugangscode',
		'TOTAL': 'Gesamt',
		'TRACKS.LOADING': 'Fahrspuren werden geladen...',
		'TRACK.WIDTH': 'Spurbreite',
		'TRACK.WIDTH.NARROW': 'Schmal',
		'TRACK.WIDTH.NORMAL': 'Normal',
		'TRACK.WIDTH.WIDE': 'Breit',
		'TRACK_LENGTH': 'Anzeigedauer Fahrspur',
		'TRACK_REPLAY': 'Fahrspurvorschau',
		'TRANSLATABLE': 'Translatable',
		'TRANSLATABLE.ADD': 'Translatable hinzufügen',
		'TRANSLATION': 'Übersetzung',
		'TRANSPORT': 'Transport',
		'TRANSPORT/AXLES': 'Transport/Achsen',
		'TRANSPORTAMOUNT_AXLES': 'Transportmenge/Achsen',
		'TURNINGS': 'Wendungen',
		'TURNING_OFFSET': 'Vorgewendeabstand',
		'TURNING_RADIUS': 'Wenderadius',
		'TYPE': 'Typ',
		'UNDO': 'Rückgängig',
		'UNIT': 'Einheit',
		'UNKNOWN': 'Unbekannt',
		'UNTIL': 'bis',
		'UPLOAD': 'Hochladen',
		'UPLOAD.FINISHED': 'Hochladen abgeschlossen ',
		'UPLOADING': 'Hochladen',
		'USER.EDIT.SUCCESS': 'Benutzer erfolgreich bearbeitet',
		'USERNAME': 'Benutzername',
		'USERNAME.LENGTH.REQUIRED': 'Der Benutzername muss mindestens 6 Zeichen lang sein.',
		'USERNAME.TAKEN': 'Dieser Name ist bereits vergeben.',
		'USERNAME.VALID.CHARS': 'Benutzername darf nur Buchstaben, Zahlen, \"-\" und \"_\" beinhalten',
		'USERROLE': 'Benutzerrolle',
		'USERSTATUS': 'Benutzerstatus',
		'USER_CREATED': 'Benutzer angelegt.',
		'WAITING': 'Warten',
		'WARNING': 'Warnung',
		'WEEK.CURRENT': 'Zur aktuellen Woche wechseln',
		'WEEK.NEXT': 'Nächste Woche',
		'WEEK.PREVIOUS': 'Vorherige Woche',
		'WEEK.SELECTED': 'Ausgewählte Woche',
		'WEIGHING': 'Wiegung',
		'WIDTH.INVALID': 'Breite ungültig.',
		'WORKING_HOURS': 'Arbeitsstunden',
		'WORKING_TIME': 'Arbeitszeit',
		'WORKING_WIDTH': 'Arbeitsbreite',
		'WORKSTATE': 'Arbeitszustand',
		'WORKSTATES': 'Arbeitszustände',
		'YES': 'Ja',
    'NO_POSITION_MACHINE_FOUND': 'Keine Position der Maschine vorhanden',

	}
};
